<!--
//================================================================================
// ID:BC018
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:BC018
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2022/11/01 | 富士通Japan株式会社    | 新規作成
// 01.01.00 | 2023/09/29 | 富士通Japan株式会社    | 令和5年度改修対応（3次リリース）
//================================================================================
-->
<template>
	<div class="contents__main">
		<step-bar :transKbn="form.transKbn"/>
		<div class="div-right">
		</div>
		<error-message />
		<div class="contents__information padding__bottom-20">
			<div class="padding__bottom-20 padding__top-5">
				<font-awesome-icon icon="exclamation-triangle" />
				<label class="width-attention">注意事項</label>
			</div>
			<div class="contents__attention">
				<ul>
					<li>
						一定時間画面遷移がない、通信トラブル、誤操作等で予期せずログアウトした場合、入力内容が失われますので、適時、
						一時保存を行うことをおすすめします。
					</li>
				</ul>
			</div>
		</div>
		<br>
		<section>
		<h2 class="contents__h2 margin-zyokyo-title">現在のお住まいについて入力してください。</h2>
		<div class="contents__caution--div div_row">
			<div class="contents__konkyu-caution" >
				<p class="contents__caution contents__caution--multiple kaitou-tyui_bun">こちらの回答から住宅困窮度を判定し、都営住宅の使用予定者を決定します。回答が事実と相違するときは失格となることがあります。 </p>
			</div>
		</div>
		<div class="form-section div-display-block">
			<div class="form-section-wrap">
				<p class="item-name">一緒に住んでいる方（申込者本人を含む）の年齢別の人数を選択してください。親族のほか、友人・知人を含めた人数です。
					<span class="contents__hissu2">必須</span>
				</p>
				<!--PC-->
					<div class="contents__div--PC ninzuline__height">
					<label class="question_indent font-size">・１１歳以下：
						<list-box
							class="contents__input--select" 
							:modelValue="form.nuNinzu1"
							:name="'年齢別人数（11歳以下）'"
							:groupId="'nuNinzuInfo'"
							:cdType="'L0069'"
							:cdKbn="CD_HANDLE_TYPE.ID_CD"
							@update:modelValue="form.nuNinzu1 = $event"
							ref="nuNinzu1"
							tabindex="1">
						</list-box>
					</label>
					<br>
					<label class="question_indent font-size">・１２歳以上１７歳以下：
						<list-box
							class="contents__input--select" 
							:modelValue="form.nuNinzu2"
							:name="'年齢別人数（12歳以上17歳以下）'"
							:groupId="'nuNinzuInfo'"
							:cdType="'L0069'"
							:cdKbn="CD_HANDLE_TYPE.ID_CD"
							@update:modelValue="form.nuNinzu2 = $event"
							ref="nuNinzu2"
							tabindex="2">
						</list-box>
					</label>
					<br>
					<label class="question_indent font-size">・１８歳以上６４歳以下：
						<list-box
							class="contents__input--select" 
							:modelValue="form.nuNinzu3"
							:name="'年齢別人数（18歳以上64歳以下）'"
							:groupId="'nuNinzuInfo'"
							:cdType="'L0069'"
							:cdKbn="CD_HANDLE_TYPE.ID_CD"
							@update:modelValue="form.nuNinzu3 = $event"
							ref="nuNinzu3"
							tabindex="3">
						</list-box>
					</label>
					<br>
					<label class="question_indent font-size">・６５歳以上：
						<list-box
							class="contents__input--select" 
							:modelValue="form.nuNinzu4"
							:name="'年齢別人数（65歳以上）'"
							:groupId="'nuNinzuInfo'"
							:cdType="'L0069'"
							:cdKbn="CD_HANDLE_TYPE.ID_CD"
							@update:modelValue="form.nuNinzu4 = $event"
							ref="nuNinzu4"
							tabindex="4">
						</list-box>
					</label>
				</div>
				<itemerror-message :groupId="'nuNinzuInfo'" class="contents__div--PC"/>
				<!--スマホ-->
				<div class="contents__div--MOBILE ninzuline__height">
					<div class="nuNinzuTitle__height">
						<label class="question_indent">・１１歳以下：</label>
					</div>
					<div class="nuNinzulist__margin">
						<list-box
							class="contents__input--select" 
							:modelValue="form.nuNinzu1"
							:name="'年齢別人数（11歳以下）'"
							:groupId="'nuNinzuInfo'"
							:cdType="'L0069'"
							:cdKbn="CD_HANDLE_TYPE.ID_CD"
							@update:modelValue="form.nuNinzu1 = $event"
							ref="nuNinzu01"
							tabindex="1">
						</list-box>
					</div>
					<div class="nuNinzuTitle__height">
						<label class="question_indent">・１２歳以上１７歳以下：</label>
					</div>
					<div class="nuNinzulist__margin">
						<list-box
							class="contents__input--select" 
							:modelValue="form.nuNinzu2"
							:name="'年齢別人数（12歳以上17歳以下）'"
							:groupId="'nuNinzuInfo'"
							:cdType="'L0069'"
							:cdKbn="CD_HANDLE_TYPE.ID_CD"
							@update:modelValue="form.nuNinzu2 = $event"
							ref="nuNinzu02"
							tabindex="2">
						</list-box>
					</div>
					<div class="nuNinzuTitle__height">
						<label class="question_indent">・１８歳以上６４歳以下：</label>
					</div>
					<div class="nuNinzulist__margin">
						<list-box
							class="contents__input--select" 
							:modelValue="form.nuNinzu3"
							:name="'年齢別人数（18歳以上64歳以下）'"
							:groupId="'nuNinzuInfo'"
							:cdType="'L0069'"
							:cdKbn="CD_HANDLE_TYPE.ID_CD"
							@update:modelValue="form.nuNinzu3 = $event"
							ref="nuNinzu03"
							tabindex="3">
						</list-box>
					</div>
					<div class="nuNinzuTitle__height">
						<label class="question_indent">・６５歳以上：</label>
					</div>
					<div class="nuNinzulist__margin">
						<list-box
							class="contents__input--select" 
							:modelValue="form.nuNinzu4"
							:name="'年齢別人数（65歳以上）'"
							:groupId="'nuNinzuInfo'"
							:cdType="'L0069'"
							:cdKbn="CD_HANDLE_TYPE.ID_CD"
							@update:modelValue="form.nuNinzu4 = $event"
							ref="nuNinzu04"
							tabindex="4">
						</list-box>
						<itemerror-message :groupId="'nuNinzuInfo'"/>
					</div>
				</div>
			</div>
		</div>
		<div class="form-section background__color--light-gray">
			<div class="form-section-wrap">
				<p class="item-name">一緒に住んでいる親族（申込者本人を含む）のうち寝たきりの病人等の人数を選択してください。友人・知人は含めないでください。</p>
				<div class="question_indent">
					<list-box
						class="contents__input--select"
						:modelValue="form.nuNetakirininzu"
						:name="'寝たきり人数'"
						:groupId="'nuNetakirininzuInfo'"
						:cdType="'L0069'"
						:cdKbn="CD_HANDLE_TYPE.ID_CD"
						@update:modelValue="form.nuNetakirininzu = $event"
						ref="nuNetakirininzu"
						tabindex="5"/>
						<itemerror-message :groupId="'nuNetakirininzuInfo'"/>
					<div class="margin-netakiri">
						<caution-message
							:classDiv="'font-size'"
							:tyuibunItems="disp.netakiriTyuiItems"
						/>
					</div>
				</div>
			</div>
		</div>
		<div class="form-section">
			<div class="form-section-wrap">
				<p class="item-name">一緒に住んでいる親族（申込者本人を含む）のうち心身障害者の人数と現在有効な手帳の等級等を選択してください。友人・知人は含めないでください。</p>
				<label class="question_indent font-size">・人数：
					<list-box
						class="contents__input--select"
						:name="'障害者人数'"
						:modelValue="form.nuSyogaisyaninzu"
						:groupId="'nuSyogaisyaninzuInfo'"
						:cdType="'L0070'"
						:cdKbn="CD_HANDLE_TYPE.ID_CD"
						ref="nuSyogaisyaninzu"
						@update:modelValue="selectTetyoNinzu"
						tabindex="6" />
					<itemerror-message :groupId="'nuSyogaisyaninzuInfo'"/>
				</label>
				<div id="isSyogaiTetyo" v-if="disp.isTetyoOpen">
					<div class="cond__checkbox width-madori-item tetyoAll__margin" >
						<div class="contents__input--checkbox font-size">・手帳（手帳や等級等が異なる方がいる場合は、複数選択してください）<br>
							<div class="contents__div--PC">
								<div class="sintokyuTitle__margin font-size">〇 身体障害者手帳：</div>
								<div class="sintokyuCheck__margin">
									<check-box
										:classDiv="'chkbox-width font-size'"
										:modelValue="form.sintokyu"
										:cdType="'L0064'"
										:name="'身体障害者手帳'"
										:groupId="'tetyoInfo'"
										@update:modelValue="form.sintokyu = $event"
										ref="sintokyu"
										tabindex="7"/>
									<itemerror-message :groupId="'sintokyuInfo'"/>
								</div>
								<div class="aiteidoTitle__margin font-size">〇 愛の手帳：</div>
								<div class="aiteidoCheck__margin">
									<check-box
										:classDiv="'chkbox-width font-size'"
										:modelValue="form.aiteido"
										:cdType="'L0065'"
										:name="'愛の手帳'"
										:groupId="'tetyoInfo'"
										@update:modelValue="form.aiteido = $event"
										ref="aiteido"
										tabindex="8"/>
									<itemerror-message :groupId="'aiteidoInfo'"/>
								</div>
								<div class="seitokyuTitle__margin font-size">〇 精神障害者保健福祉手帳※：</div>
								<div class="seitokyuCheck__margin ">
									<check-box
										:classDiv="'chkbox-width font-size'"
										:modelValue="form.seitokyu"
										:cdType="'L0066'"
										:name="'精神障害者保健福祉手帳'"
										:groupId="'tetyoInfo'"
										@update:modelValue="form.seitokyu = $event"
										ref="seitokyu"
										tabindex="9"/>
									<itemerror-message :groupId="'seitokyuInfo'"/>
								</div>
								<div class="syogaitokyuTitle__margin">※ 障害年金を受給している場合の年金証書の障害等級：</div>
								<div class="syogaitokyuCheck__margin">
									<check-box
										:classDiv="'chkbox-width font-size'"
										:modelValue="form.syogaitokyu"
										:cdType="'L0066'"
										:name="'年金証書の障害等級'"
										:groupId="'tetyoInfo'"
										@update:modelValue="form.syogaitokyu = $event"
										ref="syogaitokyu"
										tabindex="10"/>
									<itemerror-message :groupId="'tetyoInfo'"/>
								</div>
							</div>
							<div class="contents__div--MOBILE">
								<div class="sintokyuTitle__margin">〇 身体障害者手帳：</div>
								<div class="sintokyuCheck__margin">
									<check-box
										:classDiv="'chkbox-width'"
										:modelValue="form.sintokyu"
										:cdType="'L0064'"
										:name="'身体障害者手帳'"
										:groupId="'tetyoInfo'"
										:classItem="'width-tetyoRange'"
										@update:modelValue="form.sintokyu = $event"
										ref="sintokyu99"
										tabindex="7"/>
									<itemerror-message :groupId="'sintokyuInfo'"/>
								</div>
								<div class="aiteidoTitle__margin">〇 愛の手帳：</div>
								<div class="aiteidoCheck__margin">
									<check-box
										:classDiv="'chkbox-width'"
										:modelValue="form.aiteido"
										:cdType="'L0065'"
										:name="'愛の手帳'"
										:groupId="'tetyoInfo'"
										:classItem="'width-tetyoRange'"
										@update:modelValue="form.aiteido = $event"
										ref="aiteido99"
										tabindex="8"/>
									<itemerror-message :groupId="'aiteidoInfo'"/>
								</div>
								<div class="seitokyuTitle__margin">〇 精神障害者保健福祉手帳：</div>
								<div class="seitokyuCheck__margin">
									<check-box
										:classDiv="'chkbox-width'"
										:modelValue="form.seitokyu"
										:cdType="'L0066'"
										:name="'精神障害者保健福祉手帳'"
										:groupId="'tetyoInfo'"
										:classItem="'width-tetyoRange'"
										@update:modelValue="form.seitokyu = $event"
										ref="seitokyu99"
										tabindex="9"/>
									<itemerror-message :groupId="'seitokyuInfo'"/>
								</div>
								<div class="syogaitokyuTitle__margin">※ 障害年金を受給している場合の年金証書の障害等級：</div>
								<div class="syogaitokyuCheck__margin">
									<check-box
										:classDiv="'chkbox-width'"
										:modelValue="form.syogaitokyu"
										:cdType="'L0066'"
										:name="'年金証書の障害等級'"
										:groupId="'tetyoInfo'"
										:classItem="'width-tetyoRange'"
										@update:modelValue="form.syogaitokyu = $event"
										ref="syogaitokyu99"
										tabindex="10"/>
									<itemerror-message :groupId="'tetyoInfo'"/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="form-section background__color--light-gray div-display-block">
			<div class="form-section-wrap">
				<p class="item-name">住んでいる住宅の種類を選択してください。
					<span class="contents__hissu2">必須</span>
				</p>
				<div class="question_indent">
					<list-box
						class="contents__input--select width-nowJyutaku"
						:modelValue="form.cdNowjyutaku"
						:name="'現在の住宅の種類'"
						:groupId="'cdNowjyutakuInfo'"
						:cdType="'L0071'"
						:cdKbn="CD_HANDLE_TYPE.ID_CD"
						:requireFlg="true"
						@update:modelValue="changeJyutakuList"
						ref="cdNowjyutaku"
						tabindex="11"
					/>
					<itemerror-message :groupId="'cdNowjyutakuInfo'"/>
					<caution-message
						:tyuibunItems="disp.jyutakuTyuiItems"
					/>
				</div>
			</div>
		</div>
		<div class="form-section">
			<div class="form-section-wrap">
				<p class="item-name">親族・知人の住宅に住んでいる場合、あてはまるほうを選択してください。</p>
				<div class="contents__input--toggle_btn2 question_indent">
					<toggle-button
						:modelValue="form.kbNowjyutaku"
						:name="'現在の住宅（親族・知人）'"
						:cdType="'L0072'"
						:groupId="'kbNowjyutakuInfo'"
						:radioGroupName="'kbNowjyutaku'"
						:classItem="'toggle_btn-kbNowjyutaku'"
						@update:modelValue="form.kbNowjyutaku = $event"
						ref="kbNowjyutaku"
						tabindex="12"/>
					<itemerror-message :groupId="'kbNowjyutakuInfo'"/>
				</div>	
			</div>
		</div>
		<div class="form-section background__color--light-gray">
			<div class="form-section-wrap">
				<p class="item-name">住んでいる住宅の構造を選択してください。</p>
				<div class="question_indent">
					<list-box
						class="contents__input--select width-nowJyutaku"
						:modelValue="form.kbJyutakukozo"
						:name="'現在の住宅の構造'"
						:groupId="'kbJyutakukozoInfo'"
						:cdType="'L0073'"
						:cdKbn="CD_HANDLE_TYPE.ID_CD"
						@update:modelValue="form.kbJyutakukozo = $event"
						ref="kbJyutakukozo"
						tabindex="13"/>
					<itemerror-message :groupId="'kbJyutakukozoInfo'"/>
				</div>
			</div>
		</div>
		<div class="form-section">
			<div class="form-section-wrap">
				<p class="item-name">住んでいる住宅の間取りを選択してください。</p>
				<div class="question_indent">
					<list-box
						class="contents__input--select"
						:modelValue="form.cdNowmadori"
						:name="'現在の住宅の間取り'"
						:groupId="'cdNowmadoriInfo'"
						:cdType="'L0074'"
						:cdKbn="CD_HANDLE_TYPE.ID_CD"
						@update:modelValue="form.cdNowmadori = $event"
						ref="cdNowmadori"
						tabindex="14"/>
					<itemerror-message :groupId="'cdNowmadoriInfo'"/>
				</div>
				<div class="margin-madori">
					<div class="contents__caution--div div_row contents__caution--multiple question_indent">
						<div class="contents__caution--div_mark">
							<p class="contents__caution contents__caution--multiple ">※</p>
						</div>
						<div>
							<p class="contents__caution contents__caution--multiple ">
								親族・知人の住宅に住んでいる方は、住宅全体の間取りを選択してください。
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="form-section background__color--light-gray">
			<div class="form-section-wrap">
				<p class="item-name">住んでいる住宅の専用面積を入力してください。</p>
				<div class="question_indent">
					<label>
						<number-input
							class="contents__input--text ime-active width-senyoArea"
							:modelValue="form.nuNowsenyo"
							:maxLength="3"
							:decimalLength="1"
							:name="'現在の住宅の専用面積'"
							:groupId="'nuNowsenyoInfo'"
							:numberType="NUMBERINPUT_TYPE.INTEGER"
							@update:modelValue="form.nuNowsenyo = $event"
							ref="nuNowsenyo"
							v-on:blur="changeSenyoMenseki"
							tabindex="15"/>m&sup2;
							<itemerror-message :groupId="'nuNowsenyoInfo'"/>
					</label>
					<div class="contents__caution--div div_row contents__caution--multiple">
						<div class="contents__caution--div_mark">
							<p class="contents__caution contents__caution--multiple ">※</p>
						</div>
						<div>
							<p class="contents__caution contents__caution--multiple ">
								親族・知人の住宅に住んでいる方は、住宅全体の面積を入力してください。
							</p>
						</div>
					</div>
					<div class="contents__caution--div contents__caution--multiple">
						<div class="contents__caution--div_mark">
							<p class="contents__caution contents__caution--multiple ">※</p>
						</div>
						<div>
							<p class="contents__caution contents__caution--multiple ">
								小数点第一位まで入力できます。例）999.9 m&sup2;
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="form-section">
			<div class="form-section-wrap">
				<p class="item-name">
					住んでいる住宅の設備について、専用のものが「ない」または「ある」のいずれかを選択してください。<br>
					なお、「専用の設備がない」とは、住宅がシェアハウスなどであるため、他の住人と共用している場合や、設備そのものがない場合などをいいます。
				</p>
				<div class="div_flex">
					<div class="contents__caution--div question_indent">
						<div class="contents__caution--div_mark">
							<p class=" contents__caution--multiple">・</p>
						</div>
						<div>
							<p class=" contents__caution--multiple">専用の台所</p>
						</div>
					</div>
					<div class="toggle_indent">
						<div class="contents__input--toggle_btn" >
							<toggle-button
								:modelValue="form.fgDaidokoro"
								:name="'台所の有無'"
								:cdType="'L0075'"
								:groupId="'fgDaidokoroInfo'"
								:radioGroupName="'fgDaidokoro'"
								@update:modelValue="form.fgDaidokoro = $event"
								ref="fgDaidokoro"
								tabindex="16"/>
								<itemerror-message :groupId="'fgDaidokoroInfo'"/>
						</div>
					</div>
				</div>
				<br>
				<div class="div_flex">
					<div class="contents__caution--div question_indent">
						<div class="contents__caution--div_mark">
							<p class=" contents__caution--multiple">・</p>
						</div>
						<div>
							<p class=" contents__caution--multiple">専用のトイレ</p>
						</div>
					</div>
					<div class="toggle_indent">
						<div class="contents__input--toggle_btn">
							<toggle-button
								:modelValue="form.fgToilet"
								:name="'トイレの有無'"
								:cdType="'L0076'"
								:groupId="'fgToiletInfo'"
								:radioGroupName="'fgToilet'"
								@update:modelValue="form.fgToilet = $event"
								ref="fgToilet"
								tabindex="17"/>
								<itemerror-message :groupId="'fgToiletInfo'"/>
						</div>
					</div>
				</div>
				<br>
				<div class="div_flex">
					<div class="contents__caution--div question_indent">
						<div class="contents__caution--div_mark">
							<p class=" contents__caution--multiple">・</p>
						</div>
						<div>
							<p class=" contents__caution--multiple">専用の浴室</p>
						</div>
					</div>
					<div class="toggle_indent">
						<div class="contents__input--toggle_btn">
							<toggle-button
								:modelValue="form.fgYokusitu"
								:name="'浴室の有無'"
								:cdType="'L0077'"
								:groupId="'fgYokusituInfo'"
								:radioGroupName="'fgYokusitu'"
								@update:modelValue="form.fgYokusitu = $event"
								ref="fgYokusitu"
								tabindex="18"/>
								<itemerror-message :groupId="'fgYokusituInfo'"/>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="form-section background__color--light-gray">
			<div class="form-section-wrap">
				<p class="item-name">家賃を支払っている方について入力してください。</p>
				<div class="yatin-lineHeight">
					<label>
						<span class="font-size">・氏名：
							<text-input
								class="contents__input--text ime-active width-name-full"
								:modelValue="form.nmYatinname"
								:maxLength="30"
								:name="'家賃を払っている方の氏名'"
								:groupId="'nmYatinname'"
								@update:modelValue="form.nmYatinname = $event"
								tabindex="19"
								ref="nmYatinname"
								/>
								<itemerror-message :groupId="'nmYatinname'"/>
						</span>
					</label>
					<br>
					<div class="mosikomisyaKankei-margin font-size">
						・申込者との関係：
						<list-box
							class="contents__input--select"
							:modelValue="form.cdYatintudukigara"
							:name="'家賃を払っている方の続柄'"
							:groupId="'cdYatintudukigaraInfo'"
							:cdType="'L0106'"
							:cdKbn="CD_HANDLE_TYPE.ID_CD"
							@update:modelValue="changeYatinList"
							ref="cdYatintudukigara"
							tabindex="20"/>
							<itemerror-message :groupId="'cdYatintudukigaraInfo'"/>
					</div>
					<div class="yatin-indent">
						<text-input
							class="contents__input--text ime-active yatinEtc_margin"
							:modelValue="form.txYatintudukigaraetc"
							:maxLength="20"
							:name="'家賃を払っている方の続柄（その他）'"
							:groupId="'txYatintudukigaraetcInfo'"
							:disabledFlg="disp.yatinEtcDisabledFlg"
							@update:modelValue="form.txYatintudukigaraetc = $event"
							ref="txYatintudukigaraetc"
							tabindex="21"/>
							<itemerror-message :groupId="'txYatintudukigaraetcInfo'"/>
					</div>
				</div>
				<div class="yatin-marginTop yatinEtc_margin">
					<div class="contents__caution--div contents__caution--multiple">
						<div class="contents__caution--div_mark">
							<p class="contents__caution contents__caution--multiple ">※</p>
						</div>
						<div>
							<p class="contents__caution contents__caution--multiple ">
								「その他」の場合、具体的に記入してください。
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="form-section">
			<div class="form-section-wrap">
				<p class="item-name">負担している家賃（月額）を選択してください。</p>
				<div class="margin-yatin question_indent">
					<list-box
						class="contents__input--select"
						:modelValue="form.cdNowyatin"
						:name="'現在の家賃（月額）'"
						:groupId="'cdNowyatin'"
						:cdType="'L0078'"
						:cdKbn="CD_HANDLE_TYPE.ID_CD"
						@update:modelValue="form.cdNowyatin = $event"
						ref="cdNowyatin"
						tabindex="22"/>
					<itemerror-message :groupId="'cdNowyatin'"/>
				</div>
				<div class="question_indent">
					<div class="margin-yachinTyui1">
						<caution-message
							:classDiv="'contents__caution ryokin-tyui font-size'"
							:tyuibunItems="disp.yatinTyui1Items"
						/>
					</div>
					<div class="margin-yachinTyui2">
						<caution-message
							:classDiv="'contents__caution ryokin-tyui font-size'"
							:tyuibunItems="disp.yatinTyui2Items"
						/>
					</div>
					<div class="margin-yachinTyui2">
						<caution-message
							:classDiv="'contents__caution ryokin-tyui font-size'"
							:tyuibunItems="disp.yatinTyui3Items"
						/>
					</div>
				</div>
			</div>
		</div>
		<div class="form-section  background__color--light-gray">
			<div class="form-section-wrap">
				<p class="item-name">住宅の劣化・危険性・環境などについてお聞きします。「はい」または「いいえ」のいずれかで回答してください。</p>

				<div class="div_flex">
					<div class="contents__caution--div question_indent">
						<div class="contents__caution--div_mark">
							<p class=" contents__caution--multiple">・</p>
						</div>
						<div>
							<p class=" contents__caution--multiple">建物の老朽化により、床、壁、天井等が著しく損傷又は汚損している（自損を除く）</p>
						</div>
					</div>
					<div class="toggle_indent">
						<div class="contents__input--toggle_btn" >
							<toggle-button
								:modelValue="form.fgNaiheki"
								:name="'建物の不良度（床・壁・天井）'"
								:cdType="'L0080'"
								:groupId="'fgNaihekiInfo'"
								:radioGroupName="'fgNaiheki'"
								@update:modelValue="form.fgNaiheki = $event"
								ref="fgNaiheki"
								tabindex="23"/>
								<itemerror-message :groupId="'fgNaihekiInfo'"/>
						</div>
					</div>
				</div>
				<br>
				<div class="div_flex">
					<div class="contents__caution--div question_indent">
						<div class="contents__caution--div_mark">
							<p class=" contents__caution--multiple">・</p>
						</div>
						<div>
							<p class=" contents__caution--multiple">建物の老朽化により、外壁の剝離・剝落・亀裂等の損傷がある又は金属部が腐食している</p>
						</div>
					</div>
					<div class="toggle_indent">
						<div class="contents__input--toggle_btn" >
							<toggle-button
								:modelValue="form.fgGaiheki"
								:name="'建物の不良度（外壁）'"
								:cdType="'L0081'"
								:groupId="'fgGaihekiInfo'"
								:radioGroupName="'fgGaiheki'"
								@update:modelValue="form.fgGaiheki = $event"
								ref="fgGaiheki"
								tabindex="24"/>
								<itemerror-message :groupId="'fgGaihekiInfo'"/>
						</div>
					</div>
				</div>
				<br>
				<div class="div_flex">
					<div class="contents__caution--div question_indent">
						<div class="contents__caution--div_mark">
							<p class=" contents__caution--multiple">・</p>
						</div>
						<div>
							<p class=" contents__caution--multiple">地盤沈下又は土台の腐食等により建物が傾き、倒壊のおそれがある</p>
						</div>
					</div>
					<div class="toggle_indent">
						<div class="contents__input--toggle_btn" >
							<toggle-button
								:modelValue="form.fgKatamuki"
								:name="'建物の不良度（傾き）'"
								:cdType="'L0082'"
								:groupId="'fgKatamukiInfo'"
								:radioGroupName="'fgKatamuki'"
								@update:modelValue="form.fgKatamuki = $event"
								ref="fgKatamuki"
								tabindex="25"/>
								<itemerror-message :groupId="'fgKatamukiInfo'"/>
						</div>
					</div>
				</div>
				<br>
				<div class="div_flex">
					<div class="contents__caution--div question_indent">
						<div class="contents__caution--div_mark">
							<p class=" contents__caution--multiple">・</p>
						</div>
						<div>
							<p class=" contents__caution--multiple">主となる居室に近接して建物があり、日照時間が著しく少ない<br>また、採光も少なく、曇天等の時は、昼間も電灯を点けることが多い</p>
						</div>
					</div>
					<div class="toggle_indent">
						<div class="contents__input--toggle_btn" >
							<toggle-button
								:modelValue="form.fgNisyo"
								:name="'住環境水準（日照・通風）'"
								:cdType="'L0083'"
								:groupId="'fgNisyoInfo'"
								:radioGroupName="'fgNisyo'"
								@update:modelValue="form.fgNisyo = $event"
								ref="fgNisyo"
								tabindex="26"/>
								<itemerror-message :groupId="'fgNisyoInfo'"/>
						</div>
					</div>
				</div>
				<br>
				<div class="div_flex">
					<div class="contents__caution--div question_indent">
						<div class="contents__caution--div_mark">
							<p class=" contents__caution--multiple">・</p>
						</div>
						<div>
							<p class=" contents__caution--multiple">周囲が木造の建物に隣接していて、火事や地震のときには危険な状態である</p>
						</div>
					</div>
					<div class="toggle_indent">
						<div class="contents__input--toggle_btn" >
							<toggle-button
								:modelValue="form.fgBousai1"
								:name="'住環境水準（防災（木造））'"
								:cdType="'L0084'"
								:groupId="'fgBousai1Info'"
								:radioGroupName="'fgBousai1'"
								@update:modelValue="form.fgBousai1 = $event"
								ref="fgBousai1"
								tabindex="27"/>
								<itemerror-message :groupId="'fgBousai1Info'"/>
						</div>
					</div>
				</div>
				<br>
				<div class="div_flex">
					<div class="contents__caution--div question_indent">
						<div class="contents__caution--div_mark">
							<p class=" contents__caution--multiple">・</p>
						</div>
						<div>
							<p class=" contents__caution--multiple">住んでいる建物の外廊下が狭い又は外階段が急である等、火事や地震のときには危険な状態である</p>
						</div>
					</div>
					<div class="toggle_indent">
						<div class="contents__input--toggle_btn" >
							<toggle-button
								:modelValue="form.fgBousai2"
								:name="'住環境水準（防災（外通路））'"
								:cdType="'L0085'"
								:groupId="'fgBousai2Info'"
								:radioGroupName="'fgBousai2'"
								@update:modelValue="form.fgBousai2 = $event"
								ref="fgBousai2"
								tabindex="28"/>
								<itemerror-message :groupId="'fgBousai2Info'"/>
						</div>
					</div>
				</div>
				<br>
				<div class="div_flex">
					<div class="contents__caution--div question_indent">
						<div class="contents__caution--div_mark">
							<p class=" contents__caution--multiple">・</p>
						</div>
						<div>
							<p class=" contents__caution--multiple">住んでいる建物の一部に燃料や火薬などの危険物を取り扱っている店や倉庫がある</p>
						</div>
					</div>
					<div class="toggle_indent">
						<div class="contents__input--toggle_btn" >
							<toggle-button
								:modelValue="form.fgKikenbutu"
								:name="'住環境水準（危険物）'"
								:cdType="'L0086'"
								:groupId="'fgKikenbutuInfo'"
								:radioGroupName="'fgKikenbutu'"
								@update:modelValue="form.fgKikenbutu = $event"
								ref="fgKikenbutu"
								tabindex="29"/>
								<itemerror-message :groupId="'fgKikenbutuInfo'"/>
						</div>
					</div>
				</div>
				<br>
				<div class="div_flex">
					<div class="contents__caution--div question_indent">
						<div class="contents__caution--div_mark">
							<p class=" contents__caution--multiple">・</p>
						</div>
						<div>
							<p class=" contents__caution--multiple">工場に隣接又は近接した所に住んでおり、その工場の騒音や振動・煤煙・悪臭がひどい</p>
						</div>
					</div>
					<div class="toggle_indent">
						<div class="contents__input--toggle_btn" >
							<toggle-button
								:modelValue="form.fgSouon1"
								:name="'住環境水準（騒音・振動（工場））'"
								:cdType="'L0087'"
								:groupId="'fgSouon1Info'"
								:radioGroupName="'fgSouon1'"
								@update:modelValue="form.fgSouon1 = $event"
								ref="fgSouon1"
								tabindex="30"/>
								<itemerror-message :groupId="'fgSouon1Info'"/>
						</div>
					</div>
				</div>
				<br>
				<div class="div_flex">
					<div class="contents__caution--div question_indent">
						<div class="contents__caution--div_mark">
							<p class=" contents__caution--multiple">・</p>
						</div>
						<div>
							<p class=" contents__caution--multiple">４車線以上の道路又はバス路線等の道路に近接した所に住んでおり、自動車の騒音や振動がひどい</p>
						</div>
					</div>
					<div class="toggle_indent">
						<div class="contents__input--toggle_btn" >
							<toggle-button
								:modelValue="form.fgSouon2"
								:name="'住環境水準（騒音・振動（道路））'"
								:cdType="'L0088'"
								:groupId="'fgSouon2Info'"
								:radioGroupName="'fgSouon2'"
								@update:modelValue="form.fgSouon2 = $event"
								ref="fgSouon2"
								tabindex="31"/>
								<itemerror-message :groupId="'fgSouon2Info'"/>
						</div>
					</div>
				</div>
				<br>
				<div class="div_flex">
					<div class="contents__caution--div question_indent">
						<div class="contents__caution--div_mark">
							<p class=" contents__caution--multiple">・</p>
						</div>
						<div>
							<p class=" contents__caution--multiple">鉄道線路に近接した所に住んでおり、電車や列車の騒音や振動がひどい</p>
						</div>
					</div>
					<div class="toggle_indent">
						<div class="contents__input--toggle_btn" >
							<toggle-button
								:modelValue="form.fgSouon3"
								:name="'住環境水準（騒音・振動（電車））'"
								:cdType="'L0089'"
								:groupId="'fgSouon3Info'"
								:radioGroupName="'fgSouon3'"
								@update:modelValue="form.fgSouon3 = $event"
								ref="fgSouon3"
								tabindex="32"/>
								<itemerror-message :groupId="'fgSouon3Info'"/>
						</div>
					</div>
				</div>
				<br>
				<div class="div_flex">
					<div class="contents__caution--div question_indent">
						<div class="contents__caution--div_mark">
							<p class=" contents__caution--multiple">・</p>
						</div>
						<div>
							<p class=" contents__caution--multiple">ガード下や鉄道線路に面した所に住んでいる</p>
						</div>
					</div>
					<div class="toggle_indent">
						<div class="contents__input--toggle_btn" >
							<toggle-button
								:modelValue="form.fgSouon4"
								:name="'住環境水準（騒音・振動（路線））'"
								:cdType="'L0090'"
								:groupId="'fgSouon4Info'"
								:radioGroupName="'fgSouon4'"
								@update:modelValue="form.fgSouon4 = $event"
								ref="fgSouon4"
								tabindex="33"/>
								<itemerror-message :groupId="'fgSouon4Info'"/>
						</div>
					</div>
				</div>
				<br>
				<div class="div_flex">
					<div class="contents__caution--div question_indent">
						<div class="contents__caution--div_mark">
							<p class=" contents__caution--multiple">・</p>
						</div>
						<div>
							<p class=" contents__caution--multiple">飛行機の騒音がひどい</p>
						</div>
					</div>
					<div class="toggle_indent">
						<div class="contents__input--toggle_btn" >
							<toggle-button
								:modelValue="form.fgSouon5"
								:name="'住環境水準（騒音・振動（飛行機））'"
								:cdType="'L0091'"
								:groupId="'fgSouon5Info'"
								:radioGroupName="'fgSouon5'"
								@update:modelValue="form.fgSouon5 = $event"
								ref="fgSouon5"
								tabindex="34"/>
								<itemerror-message :groupId="'fgSouon5Info'"/>
						</div>
					</div>
				</div>
				<br>
				<div class="div_flex">
					<div class="contents__caution--div question_indent">
						<div class="contents__caution--div_mark">
							<p class=" contents__caution--multiple">・</p>
						</div>
						<div>
							<p class=" contents__caution--multiple">住んでいる建物に併設又は隣接して、午後１０時を過ぎても営業しているバー、スナック、カラオケ、飲食店、スーパー、コンビニがあり、騒音がひどい</p>
						</div>
					</div>
					<div class="toggle_indent">
						<div class="contents__input--toggle_btn" >
							<toggle-button
								:modelValue="form.fgSouon6"
								:name="'住環境水準（騒音・振動（商業施設））'"
								:cdType="'L0092'"
								:groupId="'fgSouon6Info'"
								:radioGroupName="'fgSouon6'"
								@update:modelValue="form.fgSouon6 = $event"
								ref="fgSouon6"
								tabindex="35"/>
								<itemerror-message :groupId="'fgSouon6Info'"/>
						</div>
					</div>
				</div>
				<br>
			</div>
		</div>
		<div class="form-section">
			<div class="form-section-wrap">
				<p class="item-name">住んでいる賃貸住宅を{{disp.dtTatinoki}}までに立ち退かなければならない場合、理由を選択してください。</p>
				<div class="contents__caution--multiple">
					<lavel class="question_indent">ただし、賃貸借契約期間の満了、離婚による転出、家賃滞納等の理由は立ち退きの対象となりません。</lavel>
				</div>
				<div class="question_indent">
					<list-box
						class="contents__input--select contents__enquete25"
						:modelValue="form.kbTatinoki"
						:name="'賃貸住宅の立ち退き理由'"
						:groupId="'kbTatinokiInfo'"
						:cdType="'L0093'"
						:cdKbn="CD_HANDLE_TYPE.ID_CD"
						@update:modelValue="form.kbTatinoki = $event"
						ref="kbTatinoki"
						tabindex="36"/>
					<itemerror-message :groupId="'kbTatinokiInfo'"/>
					<div>
						<div>
							<div class="contents__caution--div div_row contents__caution--multiple">
								<div>
									<caution-message
										:classDiv="'font-size'"
										:tyuibunItems="disp.tatinokiTyui1Items"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="form-section background__color--light-gray">
			<div class="form-section-wrap">
				<p class="item-name">過去２年間のポイント方式募集で、応募して低順位となった募集の年月を選択し、整理番号を入力してください。（複数選択可）</p>
				<div class="contents__div--PC">
					<div class="contents__input--checkbox font-size kobo__display div-width100" >
						<div class="chkbox-width">
							<label class="check-koubo1 kobo-label-display">	
								<span>
									<check-box
										:modelValue="form.kbKobo1"
										:name="'ポイント方式募集1'"
										:groupId="'noSeiri1Info'"
										:listItems="disp.kbKobo1List"
										@update:modelValue="form.kbKobo1 = $event"
										ref="kbKobo1"
										tabindex="37"/>
								</span>
								<span> 募集</span>
								<span class="seiribango-margin">整理番号
									<number-input
										class="contents__input--text ime-active width-seiriNo"
										:modelValue="form.noSeiri1"
										:maxLength="12"
										:numberType="NUMBERINPUT_TYPE.INTEGER"
										:name="'ポイント方式整理番号1'"
										:groupId="'noSeiri1Info'"
										@update:modelValue="form.noSeiri1 = $event"
										ref="noSeiri1"
										tabindex="38"/>番
								</span>
							</label>
							<itemerror-message :groupId="'noSeiri1Info'" class="seirino-error-msg"/>
						</div>
						<div class="chkbox-width">
							<label class="check-koubo2 kobo-label-display">
								<check-box
									:modelValue="form.kbKobo2"
									:name="'ポイント方式募集2'"
									:groupId="'noSeiri2Info'"
									:listItems="disp.kbKobo2List"
									@update:modelValue="form.kbKobo2 = $event"
									ref="kbKobo2"
									tabindex="39"/>
								<span>募集</span>
								<span class="seiribango-margin">整理番号
									<number-input
										class="contents__input--text ime-active width-seiriNo"
										:modelValue="form.noSeiri2"
										:maxLength="12"
										:numberType="NUMBERINPUT_TYPE.INTEGER"
										:name="'ポイント方式整理番号2'"
										:groupId="'noSeiri2Info'"
										@update:modelValue="form.noSeiri2 = $event"
										ref="noSeiri2"
										tabindex="40"/>番
								</span>
							</label>
							<itemerror-message :groupId="'noSeiri2Info'" class="seirino-error-msg"/>
						</div>
						<div class="chkbox-width">
							<label class="check-koubo3 kobo-label-display">
								<check-box
									:modelValue="form.kbKobo3"
									:name="'ポイント方式募集3'"
									:groupId="'noSeiri3Info'"
									:listItems="disp.kbKobo3List"
									@update:modelValue="form.kbKobo3 = $event"
									ref="kbKobo3"
									tabindex="41"/>
								<span> 募集</span>
								<span class="seiribango-margin">整理番号
									<number-input
										class="contents__input--text ime-active width-seiriNo"
										:modelValue="form.noSeiri3"
										:maxLength="12"
										:numberType="NUMBERINPUT_TYPE.INTEGER"
										:name="'ポイント方式整理番号3'"
										:groupId="'noSeiri3Info'"
										@update:modelValue="form.noSeiri3 = $event"
										ref="noSeiri3"
										tabindex="42"/>番
								</span>
							</label>
							<itemerror-message :groupId="'noSeiri3Info'" class="seirino-error-msg"/>
						</div>
						<div class="chkbox-width">
							<label class="check-koubo4 kobo-label-display">
								<check-box
									:modelValue="form.kbKobo4"
									:name="'ポイント方式募集4'"
									:groupId="'noSeiri4Info'"
									:listItems="disp.kbKobo4List"
									@update:modelValue="form.kbKobo4 = $event"
									ref="kbKobo4"
									tabindex="43"/>
								<span>募集</span>
								<span class="seiribango-margin">整理番号
									<number-input
										class="contents__input--text ime-active width-seiriNo"
										:modelValue="form.noSeiri4"
										:maxLength="12"
										:numberType="NUMBERINPUT_TYPE.INTEGER"
										:name="'ポイント方式整理番号4'"
										:groupId="'noSeiri4Info'"
										@update:modelValue="form.noSeiri4 = $event"
										ref="noSeiri4"
										tabindex="44"/>番
								</span>
							</label>
							<itemerror-message :groupId="'noSeiri4Info'" class="seirino-error-msg"/>
						</div>
						<div class='margin_kobo_tyui'>
							<div class="contents__caution--div div_row contents__caution--multiple">
								<div class="contents__caution--div_mark">
									<p class="contents__caution contents__caution--multiple ">※</p>
								</div>
								<div>
									<p class="contents__caution contents__caution--multiple ">
										整理番号がわからない場合は、番号欄は空欄のままにしておいてください。
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="contents__div--MOBILE">
					<div class="contents__input--checkbox font-size kobo__display" >
						<div class="chkbox-width">
							<label class="check-koubo1">
								<span>
									<check-box
										:modelValue="form.kbKobo1"
										:name="'ポイント方式募集1'"
										:groupId="'noSeiri1Info'"
										:listItems="disp.kbKobo1List"
										@update:modelValue="form.kbKobo1 = $event"
										ref="kbKobo01"
										tabindex="37"/>
								</span>
							</label>
							<span class="kobo-margin"> 募集</span>
						</div>
						<div class="seiribango__div-margin">
							<label>
								<span>整理番号
									<number-input
										class="contents__input--text ime-active width-seiriNo"
										:modelValue="form.noSeiri1"
										:maxLength="12"
										:numberType="NUMBERINPUT_TYPE.INTEGER"
										:name="'ポイント方式整理番号1'"
										:groupId="'noSeiri1Info'"
										@update:modelValue="form.noSeiri1 = $event"
										ref="noSeiri01"
										tabindex="38"/>番
								</span>
							</label>
							<itemerror-message :groupId="'noSeiri1Info'"/>
						</div>
						<div class="chkbox-width">
							<label class="check-koubo2">
								<check-box
									:modelValue="form.kbKobo2"
									:name="'ポイント方式募集2'"
									:groupId="'noSeiri2Info'"
									:listItems="disp.kbKobo2List"
									@update:modelValue="form.kbKobo2 = $event"
									ref="kbKobo02"
									tabindex="39"/>
							</label>
							<span class="kobo-margin">募集</span>
						</div>
						<div class="seiribango__div-margin">
							<label>
								<span>整理番号
									<number-input
										class="contents__input--text ime-active width-seiriNo"
										:modelValue="form.noSeiri2"
										:maxLength="12"
										:numberType="NUMBERINPUT_TYPE.INTEGER"
										:name="'ポイント方式整理番号2'"
										:groupId="'noSeiri2Info'"
										@update:modelValue="form.noSeiri2 = $event"
										ref="noSeiri02"
										tabindex="40"/>番
								</span>
							</label>
							<itemerror-message :groupId="'noSeiri2Info'"/>
						</div>
						<div class="chkbox-width">
							<label class="check-koubo3">
								<check-box
									:modelValue="form.kbKobo3"
									:name="'ポイント方式募集3'"
									:groupId="'noSeiri3Info'"
									:listItems="disp.kbKobo3List"
									@update:modelValue="form.kbKobo3 = $event"
									ref="kbKobo03"
									tabindex="41"/>
							</label>
							<span class="kobo-margin">募集</span>
						</div>
						<div class="seiribango__div-margin">
							<label>
								<span>整理番号
									<number-input
										class="contents__input--text ime-active width-seiriNo"
										:modelValue="form.noSeiri3"
										:maxLength="12"
										:numberType="NUMBERINPUT_TYPE.INTEGER"
										:name="'ポイント方式整理番号3'"
										:groupId="'noSeiri3Info'"
										@update:modelValue="form.noSeiri3 = $event"
										ref="noSeiri03"
										tabindex="42"/>番
								</span>
							</label>
							<itemerror-message :groupId="'noSeiri3Info'"/>
						</div>
						<div class="chkbox-width">
							<label class="check-koubo4">
								<check-box
									:modelValue="form.kbKobo4"
									:name="'ポイント方式募集4'"
									:groupId="'noSeiri4Info'"
									:listItems="disp.kbKobo4List"
									@update:modelValue="form.kbKobo4 = $event"
									ref="kbKobo04"
									tabindex="43"/>
							</label>
							<span class="kobo-margin">募集</span>
						</div>
						<div class="seiribango__div-margin">
							<label>
								<span>整理番号
									<number-input
										class="contents__input--text ime-active width-seiriNo"
										:modelValue="form.noSeiri4"
										:maxLength="12"
										:numberType="NUMBERINPUT_TYPE.INTEGER"
										:name="'ポイント方式整理番号4'"
										:groupId="'noSeiri4Info'"
										@update:modelValue="form.noSeiri4 = $event"
										ref="noSeiri04"
										tabindex="44"/>番
								</span>
							</label>
							<itemerror-message :groupId="'noSeiri4Info'"/>
						</div>
						<div>
							<div class="contents__caution--div div_row contents__caution--multiple">
								<div class="contents__caution--div_mark">
									<p class="contents__caution contents__caution--multiple ">※</p>
								</div>
								<div>
									<p class="contents__caution contents__caution--multiple ">
										整理番号がわからない場合は、番号欄は空欄のままにしておいてください。
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="form-section sinkoku__display" >
			<div class="form-section-wrap">
				<p class="item-name">申告欄（住宅について補足事項がある場合、入力してください。）</p>
				<div>
					<div class="contents__caution--div contents__caution--multiple margin__sinkoku">
						<caution-message
							:classDiv="'font-size'"
							:tyuibunItems="disp.SinkokuTyuiItems"
						/>
					</div>
					<div class='div_row'>
						<textarea-input
							class="contents__input--text margin__bottom-8 width-textarea ime-active width-sinkoku"
							:modelValue="form.txSinkoku"
							:maxLength="400"
							:name="'申告欄'"
							:groupId="'txSinkoku'"
							@update:modelValue="form.txSinkoku = $event"
							ref="txSinkoku"
							tabindex="45"/>
							<itemerror-message :groupId="'txSinkoku'"/>
					</div>
				</div>
			</div>
		</div>
		<br>
		<h2 class="contents__h2 seiyakuTitle__margin" >誓約・同意事項について</h2>
		<table class="contents__table--stripe detail">
			<tbody>
				<tr>
					<th class="contents__input--title line-height">申込確定にあたっては、以下の事項に誓約・同意することが必要です。
						<span class="contents__hissu margin__top-keiyakudoi">必須</span>
					</th>
					<td class="padding__top-zero font-size">
						<div class="doui-tyui">
							<seikyu-message
								:tyuibunItems="disp.seiyakuTyuiItems"
							/>
						</div>
						<div class="width-seiyakuDoui">
							<check-box
								:classDiv="'font-size'"
								:modelValue="form.fgSeiyakuDoui"
								:name="'誓約・同意'"
								:groupId="'fgSeiyakuDoui'"
								:listItems="disp.seiyakuDouiList"
								:requireFlg="true"
								@update:modelValue="form.fgSeiyakuDoui = $event"
								ref="fgSeiyakuDoui"
								tabindex="46" />
						</div>
						<itemerror-message :groupId="'fgSeiyakuDoui'"/>
					</td>
				</tr>
			</tbody>
		</table>
		<br>
		<h2 class="contents__h2" >満足度アンケートのお願い
			<br/>今後のサービス向上のため、下記アンケートにご協力をお願いします。
		</h2>
		<label></label>
		<table class="contents__table--stripe detail" >
			<tbody>
				<tr>
					<th class="contents__input--title padding__bottom-zero">{{ form.txAnketo1 }}</th>
					<td class="padding__top-zero">
						<div>
							<radio-button
								:classDiv="'font-size'"
								:modelValue="form.kbAnketo1"
								:listItems="disp.enquete1List"
								:name="'ご利用端末'"
								:radioGroupName="'enquete1'"
								:cdKbn="CD_HANDLE_TYPE.ID_CD"
								:disabledFlg="false"
								@update:modelValue="form.kbAnketo1 = $event"
								ref="enquete1"
								tabindex="141" />
						</div>
					</td>
				</tr>
				<tr>
					<th class="contents__input--title padding__bottom-zero">{{ form.txAnketo2 }}</th>
					<td class="padding__top-zero">
						<div>
							<radio-button
								:classDiv="'font-size'"
								:modelValue="form.kbAnketo2"
								:name="'操作性'"
								:cdType="'L0021'"
								:radioGroupName="'enquete2'"
								:cdKbn="CD_HANDLE_TYPE.ID_CD"
								:disabledFlg="false"
								@update:modelValue="form.kbAnketo2 = $event"
								ref="enquete2"
								tabindex="143" />
						</div>
					</td>
				</tr>
				<tr>
					<th class="contents__input--title padding__bottom-zero">{{ form.txAnketo3 }}</th>
					<td class="padding__top-zero">
						<div>
							<radio-button
								:classDiv="'font-size'"
								:modelValue="form.kbAnketo3"
								:name="'見やすさ'"
								:cdType="'L0021'"
								:radioGroupName="'enquete3'"
								:cdKbn="CD_HANDLE_TYPE.ID_CD"
								:disabledFlg="false"
								@update:modelValue="form.kbAnketo3 = $event"
								ref="enquete3"
								tabindex="148" />
						</div>
					</td>
				</tr>
				<tr>
					<th class="contents__input--title padding__bottom-zero">{{ form.txAnketo4 }}</th>
					<td class="padding__top-zero">
						<div >
							<radio-button
								:classDiv="'font-size'"
								:modelValue="form.kbAnketo4"
								:name="'わかりやすさ'"
								:cdType="'L0021'"
								:radioGroupName="'enquete4'"
								:cdKbn="CD_HANDLE_TYPE.ID_CD"
								:disabledFlg="false"
								@update:modelValue="form.kbAnketo4 = $event"
								ref="enquete4"
								tabindex="153" />
						</div>
					</td>
				</tr>
				<tr>
					<th class="contents__input--title padding__bottom-zero">{{ form.txAnketo5 }}</th>
					<td class="padding__top-zero">
						<div >
							<radio-button
								:classDiv="'font-size'"
								:modelValue="form.kbAnketo5"
								:name="'総合評価'"
								:cdType="'L0021'"
								:radioGroupName="'enquete5'"
								:cdKbn="CD_HANDLE_TYPE.ID_CD"
								:disabledFlg="false"
								@update:modelValue="form.kbAnketo5 = $event"
								ref="enquete5"
								tabindex="158" />
						</div>
					</td>
				</tr>
				<tr>
					<th class="contents__input--title padding__bottom-zero">{{ form.txAnketo6 }}</th>
					<td class="padding__top-zero">
						<div class="margin__top-9">
							<textarea-input
								class="contents__input--text width-enquete6 width-textarea"
								:modelValue="form.txAnketo6ans"
								:maxLength="400"
								:name="'アンケート回答６'"
								:groupId="'txAnketo6ans'"
								@update:modelValue="form.txAnketo6ans = $event"
								ref="txAnketo6ans"
								tabindex="163" />
							<itemerror-message :groupId="'txAnketo6ans'"/>
						</div>
					</td>
				</tr>
				<tr>
					<th class="contents__input--title padding__bottom-zero">{{ form.txAnketo7 }}</th>
					<td class="contents__enquete padding__top-zero">
						<div class="contents__div--anketo margin__top-9 margin__left-m14 ">
							<check-box
								class="font-size"
								:modelValue="form.kbAnketo7"
								:name="'上記都営住宅を選んだ理由'"
								:cdType="'L0038'"
								:classItems="disp.anketo7ansClassItems"
								@update:modelValue="form.kbAnketo7 = $event"
								ref="kbAnketo7ans"
								tabindex="164"
							/>
						</div>
						<div class="margin__anketo-etc">
							<textarea-input
								class="contents__input--text margin__bottom-8 width-textarea width-enquete7"
								:modelValue="form.txAnketo7ansetc"
								:maxLength="400"
								:name="'アンケート回答７その他'"
								:groupId="'txAnketo7ansetc'"
								@update:modelValue="form.txAnketo7ansetc = $event"
								ref="txAnketo7ansetc"
								tabindex="178" />
							<itemerror-message :groupId="'txAnketo7ansetc'"/>
						</div>
					</td>
				</tr>
				<tr>
					<th class="contents__input--title padding__bottom-zero">{{ form.txAnketo8 }}</th>
					<td class="contents__enquete padding__top-zero">
						<div class="contents__div--anketo margin__top-9 margin-anketo">
							<check-box
								class="font-size"
								:modelValue="form.kbAnketo8"
								:name="' 都営住宅のオンライン募集をどのようにお知りになりましたか'"
								:cdType="'L0039'"
								:classItems="disp.anketo8ansClassItems"
								@update:modelValue="form.kbAnketo8 = $event"
								ref="kbAnketo8ans"
								tabindex="179"
							/>
						</div>
						<div class="margin__anketo-etc">
							<textarea-input
								class="contents__input--text margin__bottom-8 width-textarea"
								:modelValue="form.txAnketo8ansetc"
								:maxLength="400"
								:name="'アンケート回答８その他'"
								:groupId="'txAnketo8ansetc'"
								@update:modelValue="form.txAnketo8ansetc = $event"
								ref="txAnketo8ansetc"
								tabindex="189" />
							<itemerror-message :groupId="'txAnketo8ansetc'"/>
						</div>
					</td>
				</tr>
				<tr>
					<th  class="contents__input--title padding__bottom-zero">{{ form.txAnketo9 }}</th>
					<td class="padding__top-zero">
						<div>
							<textarea-input
								class="contents__input--text margin__bottom-8 width-textarea width-enquete9"
								:modelValue="form.txAnketo9ans"
								:maxLength="400"
								:name="'アンケート回答９'"
								:groupId="'txAnketo9ans'"
								@update:modelValue="form.txAnketo9ans = $event"
								ref="txAnketo9ans"
								tabindex="190" />
							<itemerror-message :groupId="'txAnketo9ans'"/>
						</div>
					</td>
				</tr>
			</tbody>
		</table>

		<div align="center" class="contents__btn-statement">
			<div v-if="form.transKbn != '3'" class="contents__caution--multiple btn-statement1">
				<label class="font-size">申込みせずに入力した内容を保存する場合、「一時保存」ボタンをクリックしてください。</label>
			</div>
			<div class="contents__caution--multiple btn-statement2">
				<label class="font-size">申込みする場合、「入力内容の確認へ」ボタンをクリックしてください。</label>
			</div>
			<div class="contents__caution--multiple btn-statement3">
				<label class="font-size">世帯情報入力内容の確認画面に戻る場合、「戻る」ボタンをクリックしてください。</label>
			</div>
			<div class="contents__caution--multiple btn-statement4">
				<label class="font-size">ただし、一時保存していない場合、入力した住宅状況はすべて破棄されます。</label>
			</div>
		</div>
		<div class="contents__div--center margin__bottom-page">
			<input
				v-if="form.transKbn != '3'"
				type="button"
				value="一時保存"
				class="contents__btn--confirm btn-itiji-hozon"
				tabindex="200"
				@click="clickSaveBtn"
				/>
			<input
				type="button"
				value="入力内容の確認へ"
				class="contents__btn--confirm btn-kakunin"
				tabindex="201"
				@click="clickNyuryokuKakuninBtn"/>
			<input
				type="button"
				value="戻る"
				class="contents__btn--cancel btn-modoru"
				tabindex="202"
				@click="clickBackBtn"/>
		</div>
		</section>
	</div>
</template>

<script>
import ErrorMessage from '@/components/ErrorMessage.vue';
import TextInput from '@/components/TextInput.vue';
import NumberInput from '@/components/NumberInput.vue';
import ListBox from '@/components/ListBox.vue';
import CheckBox from '@/components/CheckBox.vue';
import RadioButton from '@/components/RadioButton.vue';
import CautionMessage from '@/components/CautionMessage.vue';
import SeiyakuMessage from '@/components/SeiyakuMessage.vue';
import ItemErrorMessage from '@/components/ItemErrorMessage.vue';
import ToggleButton from '@/components/ToggleButton.vue';
import TextAreaInput from '@/components/TextAreaInput.vue';
import StepBar from '@/components/StepBar.vue';

import { co_post, co_put, co_setError } from '@/common/ajaxUtility.js';
import { co_zenkaku2Hankaku } from '@/common/stringUtility.js';
import { co_confirmDialog, co_completedDialog} from '@/common/dialogUtility.js';
import { co_isMobile, co_isOperation, co_getBrowser, co_getOperation } from '@/common/browserUtility.js';
import { co_isEmpty } from '@/common/checkUtility.js';
import { co_getMessage } from '@/common/messageUtility.js';
import { co_toTop, co_toTrans, co_clearParam } from '@/common/screenUtility.js';

import { CD_HANDLE_TYPE, TEXTINPUT_TYPE, NUMBERINPUT_TYPE, HTTP_STATUS, DIALOG_BUTTON_LIST_KEY } from '@/const/const.js';
import { PATH_BC018_INIT, PATH_BC018_SAVE } from '@/const/route.js';
import { STORE_ERROR_IS_ERRFLG, STORE_DATA_ADD_DATA, STORE_ERROR_SET_INPUT_ERR, STORE_ERROR_CLEAR,
			STORE_VIEW_PROGRESS, STORE_VIEW_TITLE, STORE_VIEW_GET_PARAMS } from '@/const/store.js';

export default {
	name: "BC018",
	components: {
		'error-message': ErrorMessage,
		'text-input': TextInput,
		'number-input': NumberInput,
		'list-box': ListBox,
		'check-box': CheckBox,
		'radio-button': RadioButton,
		'caution-message' : CautionMessage,
		'seikyu-message': SeiyakuMessage,
		'toggle-button': ToggleButton,
		'textarea-input': TextAreaInput,
		'itemerror-message': ItemErrorMessage,
		'step-bar': StepBar,
	},
	data: function () {
		return {
			form: {
				transKbn: '',					// 遷移区分
				noJyoKyo: '',					// 連番（住宅状況情報テーブル）
				kbBosyu: '',					// 募集の種類
				kbZyutaku: '',					// 住宅の種別
				ymBosyu: '',					// 募集年月
				noMouchiku: '',					// 申込地区番号
				noRenzoku: '',					// 連番
				noUketuke: '',					// 受付番号
				kbKoubo: '',					// 公募区分
				kbMosikomi: '',					// 申込区分
				dtMosikomi: '',					// 申込日
				dtMoubirthday: '',				// 申込者生年月日
				kbGender: '',					// 性別コード
				nuNinzu1: '',					// 年齢別人数（11歳以下）
				nuNinzu2: '',					// 年齢別人数（12歳以上17歳以下）
				nuNinzu3: '',					// 年齢別人数（18歳以上64歳以下）
				nuNinzu4: '',					// 年齢別人数（65歳以上）
				nuNetakirininzu: '',			// 寝たきり人数
				nuSyogaisyaninzu: '',			// 障害者人数
				sintokyu: '',					// 身体障害者手帳
				kbSintokyu1: '',				// 身体障害者手帳等級１
				kbSintokyu2: '',				// 身体障害者手帳等級２
				kbSintokyu3: '',				// 身体障害者手帳等級３
				kbSintokyu4: '',				// 身体障害者手帳等級４
				kbSintokyu5: '',				// 身体障害者手帳等級５
				kbSintokyu6: '',				// 身体障害者手帳等級６
				kbSintokyu7: '',				// 身体障害者手帳等級７
				aiteido: '',					// 愛の手帳
				kbAiteido1: '',					// 愛の手帳程度１
				kbAiteido2: '',					// 愛の手帳程度２
				kbAiteido3: '',					// 愛の手帳程度３
				kbAiteido4: '',					// 愛の手帳程度４
				seitokyu: '',					// 精神障害者保健福祉手帳
				kbSeitokyu1: '',				// 精神障害者保健福祉手帳等級１
				kbSeitokyu2: '',				// 精神障害者保健福祉手帳等級２
				kbSeitokyu3: '',				// 精神障害者保健福祉手帳等級３
				syogaitokyu: '',				// 年金証書の障害
				kbSyogaitokyu1: '',				// 年金証書の障害等級１
				kbSyogaitokyu2: '',				// 年金証書の障害等級２
				kbSyogaitokyu3: '',				// 年金証書の障害等級３
				cdNowjyutaku: '',				// 現在の住宅の種類
				kbNowjyutaku: '',				// 現在の住宅（親族・知人）
				kbJyutakukozo: '',				// 現在の住宅の構造
				cdNowmadori: '',				// 現在の住宅の間取り
				nuNowsenyo: '',					// 現在の住宅の専用面積
				fgDaidokoro: '',				// 台所の有無
				fgToilet: '',					// トイレの有無
				fgYokusitu: '',					// 浴室の有無
				nmYatinname: '',				// 家賃を払っている方の氏名
				cdYatintudukigara: '',			// 家賃を払っている方の続柄
				txYatintudukigaraetc: '',		// 家賃を払っている方の続柄（その他）
				cdNowyatin: '',					// 現在の家賃（月額）
				fgNaiheki: '',					// 建物の不良度（床・壁・天井）
				fgGaiheki: '',					// 建物の不良度（外壁）
				fgKatamuki: '',					// 建物の不良度（傾き）
				fgNisyo: '',					// 住環境水準（日照・通風）
				fgBousai1: '',					// 住環境水準（防災（木造））
				fgBousai2: '',					// 住環境水準（防災（外通路））
				fgKikenbutu: '',				// 住環境水準（危険物）
				fgSouon1: '',					// 住環境水準（騒音・振動（工場））
				fgSouon2: '',					// 住環境水準（騒音・振動（道路））
				fgSouon3: '',					// 住環境水準（騒音・振動（電車））
				fgSouon4: '',					// 住環境水準（騒音・振動（路線））
				fgSouon5: '',					// 住環境水準（騒音・振動（飛行機））
				fgSouon6: '',					// 住環境水準（騒音・振動（商業施設））
				kbTatinoki: '',					// 賃貸住宅の立ち退き理由
				kbKobo1: '',					// ポイント方式募集1
				ymKobo1: '',					// ポイント方式募集年月1
				noSeiri1: '',					// ポイント方式整理番号1
				kbKobo2: '',					// ポイント方式募集2
				ymKobo2: '',					// ポイント方式募集年月2
				noSeiri2: '',					// ポイント方式整理番号2
				kbKobo3: '',					// ポイント方式募集3
				ymKobo3: '',					// ポイント方式募集年月3
				noSeiri3: '',					// ポイント方式整理番号3
				kbKobo4: '',					// ポイント方式募集4
				ymKobo4: '',					// ポイント方式募集年月4
				noSeiri4: '',					// ポイント方式整理番号4
				txSinkoku: '',					// 申告欄
				fgSeiyakuDoui: '',				// 誓約・同意
				txAnketo1: '',					// アンケート表題１
				kbAnketo1: '',					// アンケート回答１
				txAnketo2: '',					// アンケート表題２
				kbAnketo2: '',					// アンケート回答２
				txAnketo3: '',					// アンケート表題３
				kbAnketo3: '',					// アンケート回答３
				txAnketo4: '',					// アンケート表題４
				kbAnketo4: '',					// アンケート回答４
				txAnketo5: '',					// アンケート表題５
				kbAnketo5: '',					// アンケート回答５
				txAnketo6: '',					// アンケート表題６
				txAnketo6ans: '',				// アンケート回答６
				txAnketo7: '',					// アンケート表題７
				kbAnketo7: '',					// アンケート回答７
				txAnketo7ansetc: '',			// アンケート回答７その他
				txAnketo8: '',					// アンケート表題８
				kbAnketo8: '',					// アンケート回答８
				txAnketo8ansetc: '',			// アンケート回答８その他
				txAnketo9: '',					// アンケート表題９
				txAnketo9ans: '',				// アンケート回答９
				txOstype: '',					// ＯＳの種類
				txOsversion: '',				// ＯＳのバージョン
				txBrowsertype: '',				// ブラウザの種類
			},
			disp: {
				netakiriTyuiItems: ['C0224'],	// 寝たきり注意文リスト
				jyutakuTyuiItems: [],			// 現在の住宅の種類注意文
				yatinTyui1Items: ['C0225'],		// 現在の家賃（月額）注意文１リスト
				yatinTyui2Items: ['C0226'],		// 現在の家賃（月額）注意文２リスト
				yatinTyui3Items: ['C0227'],		// 現在の家賃（月額）注意文３リスト
				tatinokiTyui1Items: ['C0229'],	// 賃貸住宅の立ち退き注意文１リスト
				kbKobo1List: [],				// ポイント方式募集１リスト
				kbKobo2List: [],				// ポイント方式募集２リスト
				kbKobo3List: [],				// ポイント方式募集３リスト
				kbKobo4List: [],				// ポイント方式募集４リスト
				SinkokuTyuiItems: ['C0249'],	// 申告欄注意文リスト	
				seiyakuTyuiItems: ['C0027'],	// 制約・同意注意文リスト
				seiyakuDouiList: [],			// 誓約・同意リスト
				dispYmKobo1: '',				// ポイント方式募集年月1(表示用)
				dispYmKobo2: '',				// ポイント方式募集年月2(表示用)
				dispYmKobo3: '',				// ポイント方式募集年月3(表示用)
				dispYmKobo4: '',				// ポイント方式募集年月4(表示用)
				mobileFlg: false,				// モバイル端末フラグ	
				dtTatinoki: '',					// 立ち退き期限
				yatinEtcDisabledFlg: true,		// 家賃を払っている方の続柄（その他）活性、非活性フラグ
				isTetyoOpen: false,				// 手帳区分開閉フラグ
				enquete1List: [],				// アンケート１
				anketo7ansClassItems: [],		// アンケート７回答スタイル
				anketo8ansClassItems: [],		// アンケート８回答スタイル
			},
			transKbn: '',
			kbBosyu: '',
			kbZyutaku: '',
			ymBosyu: '',
			noMouchiku: '',
			noRenzoku: '',
			noUketuke: '',
			mosikomiInfo: [],		// 住宅状況情報
			NUMBERINPUT_TYPE: NUMBERINPUT_TYPE,
			TEXTINPUT_TYPE: TEXTINPUT_TYPE,
			CD_HANDLE_TYPE: CD_HANDLE_TYPE
		}
	},
	created: async function() {

		// ブラウザチェック
		if(!await co_isOperation()) {
			co_toTrans('BrowserError');
		}

		// エラークリア
		this.$store.commit(STORE_ERROR_CLEAR);

		// ローディング表示開始
		this.$store.commit(STORE_VIEW_PROGRESS, true);

		// 前画面からのパラメータを設定
		let param = this.$store.getters[STORE_VIEW_GET_PARAMS]('BC018');
		this.transKbn = param.transKbn;
		this.kbBosyu = param.kbBosyu;
		this.kbZyutaku = param.kbZyutaku;
		this.ymBosyu = param.ymBosyu;
		this.noMouchiku = param.noMouchiku;
		this.noRenzoku = param.noRenzoku;
		this.noUketuke = param.noUketuke;
		this.mosikomiInfo = param.mosikomiInfo;

		// 画面間パラメータを削除
		co_clearParam('BC018');

		// ブラウザ設定
		let os = await co_getOperation();
		let osInfo = os.split(',');
		this.form.txOstype = osInfo[0];				// OSの種類
		this.form.txOsversion = osInfo[1];			// OSのバージョン
		this.form.txBrowsertype = co_getBrowser();	// ブラウザの種類

		this.disp.mobileFlg = await co_isMobile();
		
		// 前画面からのパラメータを設定
		this.form.transKbn = this.transKbn;
		this.form.kbBosyu = this.kbBosyu;
		this.form.kbZyutaku = this.kbZyutaku;
		this.form.ymBosyu = this.ymBosyu;
		this.form.noMouchiku = this.noMouchiku;
		this.form.noRenzoku = this.noRenzoku;
		this.form.noUketuke = this.noUketuke;

		// 遷移区分からパラメータを取得
		if (this.form.transKbn == '3') {
			// 画面タイトルの編集
			this.$store.commit(STORE_VIEW_TITLE, '住宅状況変更');
		} else {
			// 画面タイトルの編集
			this.$store.commit(STORE_VIEW_TITLE, '住宅状況入力');
		}

		// 初期表示の項目取得
		// 立ち退き期限、公募年月、アンケート、住宅状況情報
		let initInfo = await co_post(PATH_BC018_INIT, this.form, function (res, handle) {
			if (res.status == HTTP_STATUS.OK) {
				return handle(res);
			} else {
				// ローディング表示終了
				self.$store.commit(STORE_VIEW_PROGRESS, false);
			}
		});

		// 画面項目値セット
		if (initInfo != null) {
			// 初期表示の画面項目へセット
			this.disp.dtTatinoki = initInfo.dtTatinoki;
			this.form.ymKobo1 = initInfo.ymKobo1;
			this.form.ymKobo2 = initInfo.ymKobo2;
			this.form.ymKobo3 = initInfo.ymKobo3;
			this.form.ymKobo4 = initInfo.ymKobo4;
			this.disp.dispYmKobo1 = co_zenkaku2Hankaku(initInfo.dispYmKobo1);
			this.disp.dispYmKobo2 = co_zenkaku2Hankaku(initInfo.dispYmKobo2);
			this.disp.dispYmKobo3 = co_zenkaku2Hankaku(initInfo.dispYmKobo3);
			this.disp.dispYmKobo4 = co_zenkaku2Hankaku(initInfo.dispYmKobo4);

			if (initInfo.anketoHyodaiInfo != null) {
				// アンケート表題設定
				this.form.txAnketo1 = initInfo.anketoHyodaiInfo.nmAnketo1;
				this.form.txAnketo2 = initInfo.anketoHyodaiInfo.nmAnketo2;
				this.form.txAnketo3 = initInfo.anketoHyodaiInfo.nmAnketo3;
				this.form.txAnketo4 = initInfo.anketoHyodaiInfo.nmAnketo4;
				this.form.txAnketo5 = initInfo.anketoHyodaiInfo.nmAnketo5;
				this.form.txAnketo6 = initInfo.anketoHyodaiInfo.nmAnketo6;
				this.form.txAnketo7 = initInfo.anketoHyodaiInfo.nmAnketo7;
				this.form.txAnketo8 = initInfo.anketoHyodaiInfo.nmAnketo8;
				this.form.txAnketo9 = initInfo.anketoHyodaiInfo.nmAnketo9;
			}
			// 画面遷移元判定
			if (this.mosikomiInfo == null) {
				// パラメータ.住宅状況情報が空の場合（BC009から）

				if (this.form.transKbn == 2 || this.form.transKbn == 3) {
					// 遷移区分が２または３の場合

					// アンケート回答設定
					if (initInfo.anketoAnswerInfo != null) {
						this.form.kbAnketo1 = initInfo.anketoAnswerInfo.kbAnketo1;
						this.form.kbAnketo2 = initInfo.anketoAnswerInfo.kbAnketo2;
						this.form.kbAnketo3 = initInfo.anketoAnswerInfo.kbAnketo3;
						this.form.kbAnketo4 = initInfo.anketoAnswerInfo.kbAnketo4;
						this.form.kbAnketo5 = initInfo.anketoAnswerInfo.kbAnketo5;
						this.form.txAnketo6ans = initInfo.anketoAnswerInfo.txAnketo6ans;
						this.form.kbAnketo7 = initInfo.anketoAnswerInfo.kbAnketo7;
						this.form.txAnketo7ansetc = initInfo.anketoAnswerInfo.txAnketo7ansetc;
						this.form.kbAnketo8 = initInfo.anketoAnswerInfo.kbAnketo8;
						this.form.txAnketo8ansetc = initInfo.anketoAnswerInfo.txAnketo8ansetc;
						this.form.txAnketo9ans = initInfo.anketoAnswerInfo.txAnketo9ans;
					}
					

					// 住宅状況情報設定
					if (initInfo.zyutakuzyokyoInfo != null) {
						this.form.nuNinzu1 = initInfo.zyutakuzyokyoInfo.nuNinzu1;
						this.form.nuNinzu2 = initInfo.zyutakuzyokyoInfo.nuNinzu2;
						this.form.nuNinzu3 = initInfo.zyutakuzyokyoInfo.nuNinzu3;
						this.form.nuNinzu4 = initInfo.zyutakuzyokyoInfo.nuNinzu4;
						this.form.nuNetakirininzu = initInfo.zyutakuzyokyoInfo.nuNetakirininzu;
						this.form.nuSyogaisyaninzu = initInfo.zyutakuzyokyoInfo.nuSyogaisyaninzu;
						this.form.sintokyu = initInfo.zyutakuzyokyoInfo.kbSintokyu;
						this.form.kbSintokyu1 = initInfo.zyutakuzyokyoInfo.kbSintokyu1;
						this.form.kbSintokyu2 = initInfo.zyutakuzyokyoInfo.kbSintokyu2;
						this.form.kbSintokyu3 = initInfo.zyutakuzyokyoInfo.kbSintokyu3;
						this.form.kbSintokyu4 = initInfo.zyutakuzyokyoInfo.kbSintokyu4;
						this.form.kbSintokyu5 = initInfo.zyutakuzyokyoInfo.kbSintokyu5;
						this.form.kbSintokyu6 = initInfo.zyutakuzyokyoInfo.kbSintokyu6;
						this.form.kbSintokyu7 = initInfo.zyutakuzyokyoInfo.kbSintokyu7;
						this.form.aiteido = initInfo.zyutakuzyokyoInfo.kbAiteido;
						this.form.kbAiteido1 = initInfo.zyutakuzyokyoInfo.kbAiteido1;
						this.form.kbAiteido2 = initInfo.zyutakuzyokyoInfo.kbAiteido2;
						this.form.kbAiteido3 = initInfo.zyutakuzyokyoInfo.kbAiteido3;
						this.form.kbAiteido4 = initInfo.zyutakuzyokyoInfo.kbAiteido4;
						this.form.seitokyu = initInfo.zyutakuzyokyoInfo.kbSeitokyu;
						this.form.kbSeitokyu1 = initInfo.zyutakuzyokyoInfo.kbSeitokyu1;
						this.form.kbSeitokyu2 = initInfo.zyutakuzyokyoInfo.kbSeitokyu2;
						this.form.kbSeitokyu3 = initInfo.zyutakuzyokyoInfo.kbSeitokyu3;
						this.form.syogaitokyu = initInfo.zyutakuzyokyoInfo.kbSyogaitokyu;
						this.form.kbSyogaitokyu1 = initInfo.zyutakuzyokyoInfo.kbSyogaitokyu1;
						this.form.kbSyogaitokyu2 = initInfo.zyutakuzyokyoInfo.kbSyogaitokyu2;
						this.form.kbSyogaitokyu3 = initInfo.zyutakuzyokyoInfo.kbSyogaitokyu3;
						this.form.cdNowjyutaku = initInfo.zyutakuzyokyoInfo.cdNowjyutaku;
						this.form.kbNowjyutaku = initInfo.zyutakuzyokyoInfo.kbNowjyutaku;
						this.form.kbJyutakukozo = initInfo.zyutakuzyokyoInfo.kbJyutakukozo;
						this.form.cdNowmadori = initInfo.zyutakuzyokyoInfo.cdNowmadori;
						this.form.nuNowsenyo = initInfo.zyutakuzyokyoInfo.nuNowsenyo;
						this.form.fgDaidokoro = initInfo.zyutakuzyokyoInfo.fgDaidokoro;
						this.form.fgToilet = initInfo.zyutakuzyokyoInfo.fgToilet;
						this.form.fgYokusitu = initInfo.zyutakuzyokyoInfo.fgYokusitu;
						this.form.nmYatinname = initInfo.zyutakuzyokyoInfo.nmYatinname;
						this.form.cdYatintudukigara = initInfo.zyutakuzyokyoInfo.cdYatintudukigara;
						this.form.txYatintudukigaraetc = initInfo.zyutakuzyokyoInfo.txYatintudukigaraetc;
						this.form.cdNowyatin = initInfo.zyutakuzyokyoInfo.cdNowyatin;
						this.form.fgNaiheki = initInfo.zyutakuzyokyoInfo.fgNaiheki;
						this.form.fgGaiheki = initInfo.zyutakuzyokyoInfo.fgGaiheki;
						this.form.fgKatamuki = initInfo.zyutakuzyokyoInfo.fgKatamuki;
						this.form.fgNisyo = initInfo.zyutakuzyokyoInfo.fgNisyo;
						this.form.fgBousai1 = initInfo.zyutakuzyokyoInfo.fgBousai1;
						this.form.fgBousai2 = initInfo.zyutakuzyokyoInfo.fgBousai2;
						this.form.fgKikenbutu = initInfo.zyutakuzyokyoInfo.fgKikenbutu;
						this.form.fgSouon1 = initInfo.zyutakuzyokyoInfo.fgSouon1;
						this.form.fgSouon2 = initInfo.zyutakuzyokyoInfo.fgSouon2;
						this.form.fgSouon3 = initInfo.zyutakuzyokyoInfo.fgSouon3;
						this.form.fgSouon4 = initInfo.zyutakuzyokyoInfo.fgSouon4;
						this.form.fgSouon5 = initInfo.zyutakuzyokyoInfo.fgSouon5;
						this.form.fgSouon6 = initInfo.zyutakuzyokyoInfo.fgSouon6;
						this.form.kbTatinoki = initInfo.zyutakuzyokyoInfo.kbTatinoki;
						if (initInfo.zyutakuzyokyoInfo.kbKoubo1 == 0) {
							this.form.kbKobo1 = '';
						} else {
							this.form.kbKobo1 = initInfo.zyutakuzyokyoInfo.kbKoubo1;
						}
						this.form.ymKobo1 = initInfo.zyutakuzyokyoInfo.ymkoubo1;
						this.form.noSeiri1 = initInfo.zyutakuzyokyoInfo.noSeiri1;
						if (initInfo.zyutakuzyokyoInfo.kbKoubo2 == 0) {
							this.form.kbKobo2 = '';
						} else {
							this.form.kbKobo2 = initInfo.zyutakuzyokyoInfo.kbKoubo2;
						}
						this.form.ymKobo2 = initInfo.zyutakuzyokyoInfo.ymkoubo2;
						this.form.noSeiri2 = initInfo.zyutakuzyokyoInfo.noSeiri2;
						if (initInfo.zyutakuzyokyoInfo.kbKoubo3 == 0) {
							this.form.kbKobo3 = '';
						} else {
							this.form.kbKobo3 = initInfo.zyutakuzyokyoInfo.kbKoubo3;
						}
						this.form.ymKobo3 = initInfo.zyutakuzyokyoInfo.ymkoubo3;
						this.form.noSeiri3 = initInfo.zyutakuzyokyoInfo.noSeiri3;
						if ( initInfo.zyutakuzyokyoInfo.kbKoubo4 == 0) {
							this.form.kbKobo4 = '';
						} else {
							this.form.kbKobo4 = initInfo.zyutakuzyokyoInfo.kbKoubo4;
						}
						this.form.ymKobo4 = initInfo.zyutakuzyokyoInfo.ymkoubo4;
						this.form.noSeiri4 = initInfo.zyutakuzyokyoInfo.noSeiri4;
						this.form.txSinkoku = initInfo.zyutakuzyokyoInfo.txSinkoku;
					}

					// 誓約・同意の有無
					if (initInfo.fgSeiyakuDoui == 1) {
						this.form.fgSeiyakuDoui	=	'1';
					} else {
						this.form.fgSeiyakuDoui	=	'';
					}
				}
				
			} else {
				// パラメータ.住宅状況情報が空でない場合（BC019から）
				// パラメータ.住宅状況情報を画面項目で設定する
				this.form = this.mosikomiInfo;
				// ポイント方式募集１チェックボックス値クリア
				if (this.form.kbKobo1 == 0) {
					this.form.kbKobo1 = '';
				}
				// ポイント方式募集２チェックボックス値クリア
				if (this.form.kbKobo2 == 0) {
					this.form.kbKobo2 = '';
				}
				// ポイント方式募集３チェックボックス値クリア
				if (this.form.kbKobo3 == 0) {
					this.form.kbKobo3 = '';
				}
				// ポイント方式募集４チェックボックス値クリア
				if (this.form.kbKobo4 == 0) {
					this.form.kbKobo4 = '';
				}
			}
		}

		// 現在の住宅の種類注意文
		this.changeJyutakuList(this.form.cdNowjyutaku);

		// 画面制御
		this.selectTetyoNinzu(this.form.nuSyogaisyaninzu);
		this.changeYatinList(this.form.cdYatintudukigara);
		this.changeSenyoMenseki();

		// ポイント方式募集
		this.disp.kbKobo1List = [{ idCd: '1', nmCd: this.disp.dispYmKobo1}];
		this.disp.kbKobo2List = [{ idCd: '1', nmCd: this.disp.dispYmKobo2}];
		this.disp.kbKobo3List = [{ idCd: '1', nmCd: this.disp.dispYmKobo3}];
		this.disp.kbKobo4List = [{ idCd: '1', nmCd: this.disp.dispYmKobo4}];
		
		// 制約・同意
		this.disp.seiyakuDouiList = [
			{ idCd: '1', nmCd: '上記について誓約・同意する'}
		];
		
		// ご利用端末
		this.disp.enquete1List = [
			{ idCd: '1', nmCd: 'ＰＣ'},
			{ idCd: '2', nmCd: 'スマホ・タブレット'}
		];

		// アンケート回答７クラスリスト
		this.disp.anketo7ansClassItems= ['width-enquete7-column1'
										,'width-enquete7-column2'
										,'width-enquete7-column3'
										,'width-enquete7-column4'
										,'width-enquete7-column5'
										,'width-enquete7-column6'
										,'width-enquete7-column7'
										,'width-enquete7-column8'
										,'width-enquete7-column9'
										,'width-enquete7-column10'
										,'width-enquete7-column11'
										,'width-enquete7-column12'
										,'width-enquete7-long1'
										,'width-enquete7-long2'];

		// アンケート回答８クラスリスト
		this.disp.anketo8ansClassItems= ['width-enquete8'
										,'width-enquete8'
										,'width-enquete8'
										,'width-enquete8'
										,'width-enquete8'
										,'width-enquete8'
										,'width-enquete8'
										,'width-enquete8'
										,'width-enquete8-long'
										,'width-enquete8'];

		// ローディング表示終了
		this.$store.commit(STORE_VIEW_PROGRESS, false);
	},
	mounted: async function () {
		await this.$nextTick();

		this.$refs.nuNinzu1.focus();

		// ページトップへ遷移
		co_toTop();
	},
	methods: {
		// 身体障害者の人数選択時
		selectTetyoNinzu: async function(val) {
			this.form.nuSyogaisyaninzu = val;
			if (this.form.nuSyogaisyaninzu >= 1) {
				// 障害者人数リストボックスの値が1人以上の場合
				this.disp.isTetyoOpen = true;
			} else {
				this.form.sintokyu = '';
				this.form.aiteido = '';
				this.form.seitokyu = '';
				this.form.syogaitokyu = '';
				this.disp.isTetyoOpen = false;
			}
		},
		// 現在の住宅の種類リスト変更
		changeJyutakuList : function (val) {
			this.form.cdNowjyutaku = val;

			let jyutakuTyuiItems = new Array();
			if(this.form.cdNowjyutaku == '9') {
				jyutakuTyuiItems.push('C0026');
			} else if(this.form.cdNowjyutaku == '7' || this.form.cdNowjyutaku == '8') {
				jyutakuTyuiItems.push('C0025');
			}
			this.disp.jyutakuTyuiItems = jyutakuTyuiItems;
		},
		// 家賃を支払っている方の続柄
		changeYatinList: async function(val) {
			this.form.cdYatintudukigara = val;

			if (!co_isEmpty(this.form.cdYatintudukigara) && this.form.cdYatintudukigara == 7) {
				// その他を選択時
				this.disp.yatinEtcDisabledFlg = false;
			} else {
				this.disp.yatinEtcDisabledFlg = true;
				this.form.txYatintudukigaraetc = '';
			}
		},

		// 現在の住宅の専用面積ロストフォーカス
		changeSenyoMenseki: async function() {
			if (String(this.form.nuNowsenyo).match(/^[0-9]+$/)) {
				this.form.nuNowsenyo += '.0';
			}
		},

		// 一時保存ボタン押下
		clickSaveBtn: async function() {
			
			// エラークリア
			this.$store.commit(STORE_ERROR_CLEAR);

			// 単項目チェック処理
			if (!await this.checkInputSave()) {
				return;
			} 

			// 確認メッセージ表示
			co_confirmDialog(co_getMessage('W0005'), this.doMosikomiSave);

			// ページトップへ遷移
			co_toTop();

		},

		// 一時保存処理
		doMosikomiSave : async function (flg) {
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {
				let saveResult = false;
				// ローディング表示開始
				this.$store.commit(STORE_VIEW_PROGRESS, true);
				
				// 画面入力値反映
				this.setDispItems();

				let data = await co_put(PATH_BC018_SAVE, this.form, function (res, handle) {

					// 一時保存処理：正常終了
					if(res.status == HTTP_STATUS.CREATED) {
						saveResult = true;
						return handle(res);
					} else {
						// 業務エラー表示
						co_setError(res.data, this.$refs);

						// プログレスバー非表示
						this.$store.commit(STORE_VIEW_PROGRESS, false);
						return;
					}
				});	
				
				if (saveResult) {

					// 住宅状況情報に登録されたため連番を付与する
					this.form.noJyoKyo = data.noRenzoku;
					
					if (this.form.transKbn == 1) {
						// 連番を付与する
						this.form.noRenzoku = data.noRenzoku;
						// 遷移区分を変更する
						this.form.transKbn = '2';
					}

					// 一時保存後入力値変更
					this.setDoneItems();

					// 入力値保持
					this.$store.commit(STORE_DATA_ADD_DATA, { id:'BC018', data: this.form });

					// プログレスバー非表示
					this.$store.commit(STORE_VIEW_PROGRESS, false);

					// 完了メッセージ表示
					co_completedDialog(co_getMessage('I0011'), this.doCompletion);
				}
			}

		},

		// 一時保存完了
		doCompletion : function (flg) {
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {
				return;
			}
		},

		// 入力内容の確認へボタン押下
		clickNyuryokuKakuninBtn: async function() {
			
			// エラークリア
			this.$store.commit(STORE_ERROR_CLEAR);

			// 過去募集チェックボックス入力値変更（未選択時のみ）
			this.setDoneItems();

			await this.$nextTick();
			
			// アコーディオン制御呼び出し
			this.selectTetyoNinzu(this.form.nuSyogaisyaninzu);

			// 単項目チェック処理
			if (!await this.checkInputSingle()) {
				// ローディング表示終了
				this.$store.commit(STORE_VIEW_PROGRESS, false);
				return;
			} 

			// 複数項目チェック処理
			if (!await this.checkInputMultiple()) {
				// ローディング表示終了
				this.$store.commit(STORE_VIEW_PROGRESS, false);
				return;
			}

			// 入力チェックエラーが存在しない場合
			if (!this.$store.getters[STORE_ERROR_IS_ERRFLG]) {

				// 受付済みの場合、住宅状況情報の連番を引き渡し
				if (this.form.transKbn == '2' || this.form.transKbn == '3') {
					this.form.noJyoKyo = this.form.noRenzoku;
				}
				
				// 画面入力値反映
				this.setDispItems();

				// 入力値保持
				this.$store.commit(STORE_DATA_ADD_DATA, { id:'BC018', data: this.form });

				// 住宅状況の確認画面に遷移
				let params = { transKbn: this.form.transKbn, mosikomiInfo: this.form };
				co_toTrans('BC019', params);
			}
		},

		// 戻るボタン押下
		clickBackBtn: function() {
			// 申込み内容の確認画面に遷移
			let params = { 
							transKbn: this.form.transKbn,
							kbBosyu: this.form.kbBosyu,
							kbZyutaku: this.form.kbZyutaku,
							ymBosyu: this.form.ymBosyu,
							noMouchiku: this.form.noMouchiku,
							noRenzoku: this.form.noRenzoku,
							noUketuke: this.form.noUketuke
						};
			co_toTrans('BC009', params);
		},

		// 単項目チェック
		checkInputSingle: async function() {

			let width = window.innerWidth;
			if (width < 768) {
				this.disp.mobileFlg = true;
			} else {
				this.disp.mobileFlg = false;
			}
			
			// 年齢別人数
			if (!this.disp.mobileFlg) {
				// PCの場合
				this.$refs.nuNinzu1.validate();
				this.$refs.nuNinzu2.validate();
				this.$refs.nuNinzu3.validate();
				this.$refs.nuNinzu4.validate();
			} else {
				// スマホの場合
				this.$refs.nuNinzu01.validate();
				this.$refs.nuNinzu02.validate();
				this.$refs.nuNinzu03.validate();
				this.$refs.nuNinzu04.validate();
			}

			// 家族人数チェック
			if ((co_isEmpty(this.form.nuNinzu1) || this.form.nuNinzu1 == 0) && 
				(co_isEmpty(this.form.nuNinzu2) || this.form.nuNinzu2 == 0) && 
				(co_isEmpty(this.form.nuNinzu3) || this.form.nuNinzu3 == 0) && 
				(co_isEmpty(this.form.nuNinzu4) || this.form.nuNinzu4 == 0) ) {
				this.$store.commit(STORE_ERROR_SET_INPUT_ERR, {id: 'nuNinzuInfo', msg: co_getMessage("E0102")});
				// PC版
				this.$refs.nuNinzu1.setError();
				this.$refs.nuNinzu2.setError();
				this.$refs.nuNinzu3.setError();
				this.$refs.nuNinzu4.setError();
				// スマホ版
				this.$refs.nuNinzu01.setError();
				this.$refs.nuNinzu02.setError();
				this.$refs.nuNinzu03.setError();
				this.$refs.nuNinzu04.setError();
				if (!this.disp.mobileFlg) {
					// PCの場合
					if (this.$store.getters[STORE_ERROR_IS_ERRFLG]) this.$refs.nuNinzu1.focus();
				} else {
					// スマホの場合
					if (this.$store.getters[STORE_ERROR_IS_ERRFLG]) this.$refs.nuNinzu01.focus();
				}
			}

			// 寝たきり人数
			this.$refs.nuNetakirininzu.validate();
			// 障害者人数
			this.$refs.nuSyogaisyaninzu.validate();
			// 手帳
			if (this.disp.isTetyoOpen) {
				if (!this.disp.mobileFlg) {
					// PCの場合
					this.$refs.sintokyu.validate();
					this.$refs.aiteido.validate();
					this.$refs.seitokyu.validate();
					this.$refs.syogaitokyu.validate();
				} else {
					// スマホの場合
					this.$refs.sintokyu99.validate();
					this.$refs.aiteido99.validate();
					this.$refs.seitokyu99.validate();
					this.$refs.syogaitokyu99.validate();
				}
			}
			// 現在の住宅の種類
			this.$refs.cdNowjyutaku.validate();
			// 現在の住宅（親族・知人）
			this.$refs.kbNowjyutaku.validate();
			// 現在の住宅の構造
			this.$refs.kbJyutakukozo.validate();
			// 現在の住宅の間取り
			this.$refs.cdNowmadori.validate();
			// 現在の住宅の専用面積
			this.$refs.nuNowsenyo.validate();
			// 台所の有無
			this.$refs.fgDaidokoro.validate();
			// トイレの有無
			this.$refs.fgToilet.validate();
			// 専用の浴室
			this.$refs.fgYokusitu.validate();
			// 家賃を払っている方の氏名
			this.$refs.nmYatinname.validate();
			// 家賃を払っている方の続柄
			this.$refs.cdYatintudukigara.validate();
			// その他
			this.$refs.txYatintudukigaraetc.validate();
			// 現在の家賃（月額）
			this.$refs.cdNowyatin.validate();
			// 建物の不良度（床・壁・天井）
			this.$refs.fgNaiheki.validate();
			// 建物の不良度（外壁）
			this.$refs.fgGaiheki.validate();
			// 建物の不良度（傾き）
			this.$refs.fgKatamuki.validate();
			// 住環境水準（日照・通風）
			this.$refs.fgNisyo.validate();
			// 住環境水準（防災（木造））
			this.$refs.fgBousai1.validate();
			// 住環境水準（防災（外通路））
			this.$refs.fgBousai2.validate();
			// 住環境水準（危険物）
			this.$refs.fgKikenbutu.validate();
			// 住環境水準（騒音・振動（工場））
			this.$refs.fgSouon1.validate();
			// 住環境水準（騒音・振動（道路））
			this.$refs.fgSouon2.validate();
			// 住環境水準（騒音・振動（電車））
			this.$refs.fgSouon3.validate();
			// 住環境水準（騒音・振動（路線））
			this.$refs.fgSouon4.validate();
			// 住環境水準（騒音・振動（飛行機））
			this.$refs.fgSouon5.validate();
			// 住環境水準（騒音・振動（商業施設））
			this.$refs.fgSouon6.validate();
			// 賃貸住宅の立ち退き理由
			this.$refs.kbTatinoki.validate();
			if (!this.disp.mobileFlg) {
				// PCの場合
				// ポイント方式募集1
				this.$refs.kbKobo1.validate();
				// ポイント方式整理番号1
				this.$refs.noSeiri1.validate();
				// ポイント方式募集2
				this.$refs.kbKobo2.validate();
				// ポイント方式整理番号2
				this.$refs.noSeiri2.validate();
				// ポイント方式募集3
				this.$refs.kbKobo3.validate();
				// ポイント方式整理番号3
				this.$refs.noSeiri3.validate();
				// ポイント方式募集4
				this.$refs.kbKobo4.validate();
				// ポイント方式整理番号4
				this.$refs.noSeiri4.validate();
			} else {
				// スマホの場合
				// ポイント方式募集1
				this.$refs.kbKobo01.validate();
				// ポイント方式整理番号1
				this.$refs.noSeiri01.validate();
				// ポイント方式募集2
				this.$refs.kbKobo02.validate();
				// ポイント方式整理番号2
				this.$refs.noSeiri02.validate();
				// ポイント方式募集3
				this.$refs.kbKobo03.validate();
				// ポイント方式整理番号3
				this.$refs.noSeiri03.validate();
				// ポイント方式募集4
				this.$refs.kbKobo04.validate();
				// ポイント方式整理番号4
				this.$refs.noSeiri04.validate();
			}
			// 申告欄
			this.$refs.txSinkoku.validate();
			// 誓約・同意
			this.$refs.fgSeiyakuDoui.validate();
			// アンケート
			this.$refs.enquete1.validate();
			this.$refs.enquete2.validate();
			this.$refs.enquete3.validate();
			this.$refs.enquete4.validate();
			this.$refs.enquete5.validate();
			this.$refs.txAnketo6ans.validate();
			this.$refs.kbAnketo7ans.validate();
			this.$refs.txAnketo7ansetc.validate();
			this.$refs.kbAnketo8ans.validate();
			this.$refs.txAnketo8ansetc.validate();
			this.$refs.txAnketo9ans.validate();

			// 入力チェックエラーが存在する場合
			if (this.$store.getters[STORE_ERROR_IS_ERRFLG]) {
				return false;
			}

			return true;
		},
		// 一時保存時単項目チェック
		checkInputSave: async function() {
			// 年齢別人数
			if (!this.disp.mobileFlg) {
				// PCの場合
				if (!co_isEmpty(this.form.nuNinzu1)) this.$refs.nuNinzu1.validate();
				if (!co_isEmpty(this.form.nuNinzu2)) this.$refs.nuNinzu2.validate();
				if (!co_isEmpty(this.form.nuNinzu3)) this.$refs.nuNinzu3.validate();
				if (!co_isEmpty(this.form.nuNinzu4)) this.$refs.nuNinzu4.validate();
			} else {
				// スマホの場合
				if (!co_isEmpty(this.form.nuNinzu01)) this.$refs.nuNinzu01.validate();
				if (!co_isEmpty(this.form.nuNinzu02)) this.$refs.nuNinzu02.validate();
				if (!co_isEmpty(this.form.nuNinzu03)) this.$refs.nuNinzu03.validate();
				if (!co_isEmpty(this.form.nuNinzu04)) this.$refs.nuNinzu04.validate();
			}
			// 寝たきり人数
			if (!co_isEmpty(this.form.nuNetakirininzu)) this.$refs.nuNetakirininzu.validate();
			// 障害者人数
			if (!co_isEmpty(this.form.nuSyogaisyaninzu)) this.$refs.nuSyogaisyaninzu.validate();
			// 手帳
			if (this.disp.isTetyoOpen) {
				if (!this.disp.mobileFlg) {
					// PCの場合
					if (!co_isEmpty(this.form.sintokyu)) this.$refs.sintokyu.validate();
					if (!co_isEmpty(this.form.aiteido)) this.$refs.aiteido.validate();
					if (!co_isEmpty(this.form.seitokyu)) this.$refs.seitokyu.validate();
					if (!co_isEmpty(this.form.syogaitokyu)) this.$refs.syogaitokyu.validate();
				} else {
					// スマホの場合
					if (!co_isEmpty(this.form.sintokyu99)) this.$refs.sintokyu99.validate();
					if (!co_isEmpty(this.form.aiteido99)) this.$refs.aiteido99.validate();
					if (!co_isEmpty(this.form.seitokyu99)) this.$refs.seitokyu99.validate();
					if (!co_isEmpty(this.form.syogaitokyu99)) this.$refs.syogaitokyu99.validate();
				}
			}
			// 現在の住宅の種類
			if (!co_isEmpty(this.form.cdNowjyutaku)) this.$refs.cdNowjyutaku.validate();
			// 現在の住宅（親族・知人）
			if (!co_isEmpty(this.form.kbNowjyutaku)) this.$refs.kbNowjyutaku.validate();
			// 現在の住宅の構造
			if (!co_isEmpty(this.form.kbJyutakukozo)) this.$refs.kbJyutakukozo.validate();
			// 現在の住宅の間取り
			if (!co_isEmpty(this.form.cdNowmadori)) this.$refs.cdNowmadori.validate();
			// 現在の住宅の専用面積
			if (!co_isEmpty(this.form.nuNowsenyo)) this.$refs.nuNowsenyo.validate();
			// 台所の有無
			if (!co_isEmpty(this.form.fgDaidokoro)) this.$refs.fgDaidokoro.validate();
			// トイレの有無
			if (!co_isEmpty(this.form.fgToilet)) this.$refs.fgToilet.validate();
			// 専用の浴室
			if (!co_isEmpty(this.form.fgYokusitu)) this.$refs.fgYokusitu.validate();
			// 家賃を払っている方の氏名
			if (!co_isEmpty(this.form.nmYatinname)) this.$refs.nmYatinname.validate();
			// 家賃を払っている方の続柄
			if (!co_isEmpty(this.form.cdYatintudukigara)) this.$refs.cdYatintudukigara.validate();
			// その他
			if (!co_isEmpty(this.form.txYatintudukigaraetc)) this.$refs.txYatintudukigaraetc.validate();
			// 現在の家賃（月額）
			if (!co_isEmpty(this.form.cdNowyatin)) this.$refs.cdNowyatin.validate();
			// 建物の不良度（床・壁・天井）
			if (!co_isEmpty(this.form.fgNaiheki)) this.$refs.fgNaiheki.validate();
			// 建物の不良度（外壁）
			if (!co_isEmpty(this.form.fgGaiheki)) this.$refs.fgGaiheki.validate();
			// 建物の不良度（傾き）
			if (!co_isEmpty(this.form.fgKatamuki)) this.$refs.fgKatamuki.validate();
			// 住環境水準（日照・通風）
			if (!co_isEmpty(this.form.fgNisyo)) this.$refs.fgNisyo.validate();
			// 住環境水準（防災（木造））
			if (!co_isEmpty(this.form.fgBousai1)) this.$refs.fgBousai1.validate();
			// 住環境水準（防災（外通路））
			if (!co_isEmpty(this.form.fgBousai2)) this.$refs.fgBousai2.validate();
			// 住環境水準（危険物）
			if (!co_isEmpty(this.form.fgKikenbutu)) this.$refs.fgKikenbutu.validate();
			// 住環境水準（騒音・振動（工場））
			if (!co_isEmpty(this.form.fgSouon1)) this.$refs.fgSouon1.validate();
			// 住環境水準（騒音・振動（道路））
			if (!co_isEmpty(this.form.fgSouon2)) this.$refs.fgSouon2.validate();
			// 住環境水準（騒音・振動（電車））
			if (!co_isEmpty(this.form.fgSouon3)) this.$refs.fgSouon3.validate();
			// 住環境水準（騒音・振動（路線））
			if (!co_isEmpty(this.form.fgSouon4)) this.$refs.fgSouon4.validate();
			// 住環境水準（騒音・振動（飛行機））
			if (!co_isEmpty(this.form.fgSouon5)) this.$refs.fgSouon5.validate();
			// 住環境水準（騒音・振動（商業施設））
			if (!co_isEmpty(this.form.fgSouon6)) this.$refs.fgSouon6.validate();
			// 賃貸住宅の立ち退き理由
			if (!co_isEmpty(this.form.kbTatinoki)) this.$refs.kbTatinoki.validate();
			if (!this.disp.mobileFlg) {
				// PCの場合
				// ポイント方式募集1
				if (!co_isEmpty(this.form.kbKobo1)) this.$refs.kbKobo1.validate();
				// ポイント方式整理番号1
				if (!co_isEmpty(this.form.noSeiri1)) this.$refs.noSeiri1.validate();
				// ポイント方式募集2
				if (!co_isEmpty(this.form.kbKobo2)) this.$refs.kbKobo2.validate();
				// ポイント方式整理番号2
				if (!co_isEmpty(this.form.noSeiri2)) this.$refs.noSeiri2.validate();
				// ポイント方式募集3
				if (!co_isEmpty(this.form.kbKobo3)) this.$refs.kbKobo3.validate();
				// ポイント方式整理番号3
				if (!co_isEmpty(this.form.noSeiri3)) this.$refs.noSeiri3.validate();
				// ポイント方式募集4
				if (!co_isEmpty(this.form.kbKobo4)) this.$refs.kbKobo4.validate();
				// ポイント方式整理番号4
				if (!co_isEmpty(this.form.noSeiri4)) this.$refs.noSeiri4.validate();
			} else {
				// スマホの場合
				// ポイント方式募集1
				if (!co_isEmpty(this.form.kbKobo01)) this.$refs.kbKobo01.validate();
				// ポイント方式整理番号1
				if (!co_isEmpty(this.form.noSeiri01)) this.$refs.noSeiri01.validate();
				// ポイント方式募集2
				if (!co_isEmpty(this.form.kbKobo02)) this.$refs.kbKobo02.validate();
				// ポイント方式整理番号2
				if (!co_isEmpty(this.form.noSeiri02)) this.$refs.noSeiri02.validate();
				// ポイント方式募集3
				if (!co_isEmpty(this.form.kbKobo03)) this.$refs.kbKobo03.validate();
				// ポイント方式整理番号3
				if (!co_isEmpty(this.form.noSeiri03)) this.$refs.noSeiri03.validate();
				// ポイント方式募集4
				if (!co_isEmpty(this.form.kbKobo04)) this.$refs.kbKobo04.validate();
				// ポイント方式整理番号4
				if (!co_isEmpty(this.form.noSeiri04)) this.$refs.noSeiri04.validate();
			}
			// 申告欄
			if (!co_isEmpty(this.form.txSinkoku)) this.$refs.txSinkoku.validate();
			// 誓約・同意
			if (!co_isEmpty(this.form.fgSeiyakuDoui)) this.$refs.fgSeiyakuDoui.validate();
			// アンケート
			if (!co_isEmpty(this.form.enquete1)) this.$refs.enquete1.validate();
			if (!co_isEmpty(this.form.enquete2)) this.$refs.enquete2.validate();
			if (!co_isEmpty(this.form.enquete3)) this.$refs.enquete3.validate();
			if (!co_isEmpty(this.form.enquete4)) this.$refs.enquete4.validate();
			if (!co_isEmpty(this.form.enquete5)) this.$refs.enquete5.validate();
			if (!co_isEmpty(this.form.txAnketo6ans)) this.$refs.txAnketo6ans.validate();
			if (!co_isEmpty(this.form.kbAnketo7ans)) this.$refs.kbAnketo7ans.validate();
			if (!co_isEmpty(this.form.txAnketo7ansetc)) this.$refs.txAnketo7ansetc.validate();
			if (!co_isEmpty(this.form.kbAnketo8ans)) this.$refs.kbAnketo8ans.validate();
			if (!co_isEmpty(this.form.txAnketo8ansetc)) this.$refs.txAnketo8ansetc.validate();
			if (!co_isEmpty(this.form.txAnketo9ans)) this.$refs.txAnketo9ans.validate();

			// 入力チェックエラーが存在する場合
			if (this.$store.getters[STORE_ERROR_IS_ERRFLG]) {
				return false;
			}

			return true;
		},

		// 複数項目チェック
		checkInputMultiple: async function() {

			let inputError = false;
			
			// 障害者人数チェック
			if (this.form.nuSyogaisyaninzu >= 1 && co_isEmpty(this.form.sintokyu)
				&& co_isEmpty(this.form.aiteido) && co_isEmpty(this.form.seitokyu)
				&& co_isEmpty(this.form.syogaitokyu) ) {
				this.$store.commit(STORE_ERROR_SET_INPUT_ERR, {id: 'tetyoInfo', msg: co_getMessage("E0103")});
				// PC版
				this.$refs.sintokyu.setError();
				this.$refs.aiteido.setError();
				this.$refs.seitokyu.setError();
				this.$refs.syogaitokyu.setError();
				// スマホ版
				this.$refs.sintokyu99.setError();
				this.$refs.aiteido99.setError();
				this.$refs.seitokyu99.setError();
				this.$refs.syogaitokyu99.setError();
				if (!this.disp.mobileFlg) {
					// PCの場合
					if (!inputError) this.$refs.sintokyu.focus();
				} else {
					// スマホの場合
					if (!inputError) this.$refs.sintokyu99.focus();
				}
				inputError = true;
			}

			// 公募年月、整理番号チェック
			let koboList = [this.form.kbKobo1, this.form.kbKobo2, this.form.kbKobo3, this.form.kbKobo4];
			let koboRefPCList = [this.$refs.kbKobo1, this.$refs.kbKobo2, this.$refs.kbKobo3, this.$refs.kbKobo4];
			let koboRefMOBILEList = [this.$refs.kbKobo01, this.$refs.kbKobo02, this.$refs.kbKobo03, this.$refs.kbKobo04];
			let seiriList = [this.form.noSeiri1, this.form.noSeiri2, this.form.noSeiri3, this.form.noSeiri4];
			let groupIdList = ['noSeiri1Info', 'noSeiri2Info', 'noSeiri3Info', 'noSeiri4Info'];

			for (let i = 0; i < 4; i++) {
				// 整理番号のみ入力されている場合
				if (!co_isEmpty(seiriList[i])) {
					if (koboList[i].indexOf('1') == -1) {
						this.$store.commit(STORE_ERROR_SET_INPUT_ERR, {id: groupIdList[i], msg: co_getMessage("E0121")});
						// PC版
						koboRefPCList[i].setError();
						// スマホ版
						koboRefMOBILEList[i].setError();

						if (!this.disp.mobileFlg) {
							// PCの場合
							if (!inputError) koboRefPCList[i].focus();
						} else {
							// スマホの場合
							if (!inputError) koboRefMOBILEList[i].focus();
						}
						inputError = true;
					}
				}
			}

			// 入力チェックエラーが存在する場合
			if (this.$store.getters[STORE_ERROR_IS_ERRFLG]) {
				return false;
			}

			return true;
			
		},

		// 画面入力値反映
		setDispItems: async function() {

			// 年齢別人数（11歳以下）
			if (co_isEmpty(this.form.nuNinzu1)) {
				this.form.nuNinzu1 = '0';
			}
			// 年齢別人数（12歳以上17歳以下）
			if (co_isEmpty(this.form.nuNinzu2)) {
				this.form.nuNinzu2 = '0';
			}
			// 年齢別人数（18歳以上64歳以下）
			if (co_isEmpty(this.form.nuNinzu3)) {
				this.form.nuNinzu3 = '0';
			}
			// 年齢別人数（65歳以上）
			if (co_isEmpty(this.form.nuNinzu4)) {
				this.form.nuNinzu4 = '0';
			}

			// 寝たきり人数
			if (co_isEmpty(this.form.nuNetakirininzu)) {
				this.form.nuNetakirininzu = '0';
			}

			// 障害者人数
			if (co_isEmpty(this.form.nuSyogaisyaninzu)) {
				this.form.nuSyogaisyaninzu = '0';
			}

			// 障害者等級初期化
			this.form.kbSintokyu1 = '0'
			this.form.kbSintokyu2 = '0'
			this.form.kbSintokyu3 = '0'
			this.form.kbSintokyu4 = '0'
			this.form.kbSintokyu5 = '0'
			this.form.kbSintokyu6 = '0'
			this.form.kbSintokyu7 = '0'
			this.form.kbAiteido1 = '0';
			this.form.kbAiteido2 = '0';
			this.form.kbAiteido3 = '0';
			this.form.kbAiteido4 = '0';
			this.form.kbSeitokyu1 = '0';
			this.form.kbSeitokyu2 = '0';
			this.form.kbSeitokyu3 = '0';
			this.form.kbSyogaitokyu1 = '0';
			this.form.kbSyogaitokyu2 = '0';
			this.form.kbSyogaitokyu3 = '0';

			// 身体障害者手帳
			if (!co_isEmpty(this.form.sintokyu)) {
				let sintokyuList = this.form.sintokyu.split(',');
				for (let i = 0; i < sintokyuList.length; i++) {
					switch (sintokyuList[i]) {
						case '1':
							this.form.kbSintokyu1 = '1';
							break;
						case '2':
							this.form.kbSintokyu2 = '1';
							break;
						case '3':
							this.form.kbSintokyu3 = '1';
							break;
						case '4':
							this.form.kbSintokyu4 = '1';
							break;
						case '5':
							this.form.kbSintokyu5 = '1';
							break;
						case '6':
							this.form.kbSintokyu6 = '1';
							break;
						case '7':
							this.form.kbSintokyu7 = '1';
							break;
					}
				}
			}
			// 愛の手帳
			if (!co_isEmpty(this.form.aiteido)) {		
				let aiteidoList = this.form.aiteido.split(',');
				for (let i = 0; i < aiteidoList.length; i++) {
					switch (aiteidoList[i]) {
						case '1':
							this.form.kbAiteido1 = '1';
							break;
						case '2':
							this.form.kbAiteido2 = '1';
							break;
						case '3':
							this.form.kbAiteido3 = '1';
							break;
						case '4':
							this.form.kbAiteido4 = '1';
							break;
					}
				}
			}
			// 精神障害者保険福祉手帳
			if (!co_isEmpty(this.form.seitokyu)) {
				
				let seitokyuList = this.form.seitokyu.split(',');
				for (let i = 0; i < seitokyuList.length; i++) {
					switch (seitokyuList[i]) {
						case '1':
							this.form.kbSeitokyu1 = '1';
							break;
						case '2':
							this.form.kbSeitokyu2 = '1';
							break;
						case '3':
							this.form.kbSeitokyu3 = '1';
							break;
					}
				}
			}
			// 障害年金を受給している場合の年金証書の障害等級
			if (!co_isEmpty(this.form.syogaitokyu)) {
				let syogaitokyuList = this.form.syogaitokyu.split(',');
				for (let i = 0; i < syogaitokyuList.length; i++) {
					switch (syogaitokyuList[i]) {
						case '1':
							this.form.kbSyogaitokyu1 = '1';
							break;
						case '2':
							this.form.kbSyogaitokyu2 = '1';
							break;
						case '3':
							this.form.kbSyogaitokyu3 = '1';
							break;
					}
				}
			}

			// 現在の住宅（親族・知人）
			if (co_isEmpty(this.form.kbNowjyutaku)) {
				this.form.kbNowjyutaku = '0';
			}
			// 現在の住宅の構造
			if (co_isEmpty(this.form.kbJyutakukozo)) {
				this.form.kbJyutakukozo = '0';
			}
			// 賃貸住宅の立ち退き理由	
			if (co_isEmpty(this.form.kbTatinoki)) {
				this.form.kbTatinoki = '0';
			}
			// 公募区分１
			if (co_isEmpty(this.form.kbKobo1)) {
				this.form.kbKobo1 = '0';
			}
			// 公募区分２
			if (co_isEmpty(this.form.kbKobo2)) {
				this.form.kbKobo2 = '0';
			}
			// 公募区分３
			if (co_isEmpty(this.form.kbKobo3)) {
				this.form.kbKobo3 = '0';
			}
			// 公募区分４
			if (co_isEmpty(this.form.kbKobo4)) {
				this.form.kbKobo4 = '0';
			}
		},
		// イベント終了後入力値変更
		setDoneItems: async function() {
			// 公募区分
			if (this.form.kbKobo1 == '0') {
				this.form.kbKobo1 = '';

			}
			if (this.form.kbKobo2 == '0') {
				this.form.kbKobo2 = '';

			}
			if (this.form.kbKobo3 == '0') {
				this.form.kbKobo3 = '';

			}
			if (this.form.kbKobo4 == '0') {
				this.form.kbKobo4 = '';

			}
		},
	}
};
</script>

<style scoped>
.tetyoAll__margin {
	margin-top: 15px; margin-left: 17px;
}

.contents__hissu2 {
	background-color: #ee0000;
	color: #ffffff;
	font-size: 12px;
	margin: 5px 0;
	padding: 2px 2px;
	border-radius: 3px;
	line-height: 1.3em;
}

.form-section {
	display: flex;
	border: 1px solid #dadce0;
	border-radius: 8px;
	margin-left: 25px;
	margin-bottom: 12px;
	background-color: #fdfdfd;
	}

.form-section-textArea {
	border: 1px solid #dadce0;
	border-radius: 8px;
	margin-left: 25px;
	margin-bottom: 12px;
	background-color: #fff;
}
.form-section .form-section-wrap .item-name {
	letter-spacing: 0.1px;
	line-height: 24px;
	color: #202124;
	font-weight: bold;
	width: 100%;
	word-break: break-word;
	margin-bottom: 16px;
}
.form-section .form-section-wrap .item-name span {
	margin-left: 5px;
	font-weight: bold;
}

.width-textarea {
	width: -webkit-fill-available;
}

.margin__anketo-etc {
	margin-top: 3px;
}

.kaitou-tyui_bun {
	color:red;
}

.text_etc_disabled {
	color: #FFF;
	background: #AAA;
}

.div_flex {
	display:flex;
	flex-direction: column;
}

.contents__input--toggle_btn2 input {
	display: none;
}

.div-display-block {
	display: block;
}

.sinkoku__display {
	display:block;
}

.sinkoku__margin {
	margin-top: 10px; margin-bottom: 20px;
}

.seiyakuTitle__margin {
	margin-top: 5px;
}

.margin__sinkoku {
	margin-top: -10px;
}


/* 端末がPCの場合 */
@media screen and (min-width: 768px) {

	.contents__div--MOBILE {
		display: none;
	}

	/* 入力項目：必須マーク */
	.contents__hissu2 {
		right: 5%;
	}

	.font-size {
		font-size: 16px !important;
	}

	.contents__main {
		margin-left: 1% !important;
		margin-right: 1% !important;
	}

	.contents__input-main {
		margin-top: -2%;
	}

	.margin-zyokyo-title {
		margin-top: 10px;
	}

	.contents__table--stripe td {
		line-height: 0px;
	}

	.check-koubo1 {
		margin-top: 20px;
		padding-left: 3px !important;
	}

	.check-koubo2,
	.check-koubo3,
	.check-koubo4 {
		margin-top: 18px;
		padding-left: 3px !important;
	}

	.margin-riyuTyui {
		margin-top: 5px;
		margin-left: 5px;
	}

	.width-nowJyutaku {
		width: auto;
	}

	_::-webkit-full-page-media, _:future, :root {
		height: 58px;
	}

	.netakiri-tyui {
		line-height: 1.2em;
		padding-top: 15px;
		display: flex;
	}

	.tatinoki-tyui {
		line-height: 1.2em;
		padding-top: 10px;
		display: flex;
		width: 97%;
	}

	.contents__enquete25 {
		margin-top: 10px;
	}

	.width-senyoArea {
		margin-right: 10px;
		width: 58px;
		text-align: right;
	}

	.width-seiriNo {
		margin-right: 10px;
		margin-left: 5px;
		width: 130px;
		text-align: right;
	}

	.margin-yachinTyui1 {
		line-height: 1.2em;
		display: flex;
		width: 97%;
	}

	.margin-yachinTyui2 {
		line-height: 1.2em;
		margin-top: -10px;
		display: flex;
		width: 97%;
	}

	.margin-mensekiTyui {
		line-height: 1.2em;
		padding-top: 15px;
		display: flex;
	}

	.margin-madoriTyui {
		margin-top: 15px;
	}

	.detail .no_border_bottom .detail_split {
		border-bottom: none;
	}
		
	.contents__thtd--btn {
		background-color: #fdfdfd;
		border-color: #fdfdfd;
	}

	.content {
		display:none;
	}
	.contents__caution--multiple {
		line-height: 1.4em !important;
	}

	.contents__btn-statement {
		text-align: left;
		padding-left: 15%;
		margin-top: 15px;
		margin-bottom: 15px;
	}

	.doui-tyui {
		line-height: 21px;
		margin-bottom: 10px;
	}

	.width-seiyakuDoui {
		margin-top: 25px;   
		margin-bottom: 15px;
		margin-left: -10px;
	}

	.contents__div--anketo {
		line-height: 1.7em;
	}

	.width-enquete6,
	.width-enquete7,
	.width-enquete9 {
		height: 96px;
		margin-bottom: 8px;
	}

	.width-name-full {
		width: 400px;
	}

	.contents__attention {
		margin-top:10px;
		line-height:20px;
	}

	.contents__konkyu-caution {
		margin-left: 23px;
		margin-bottom: 10px;
	}

	.form-section .form-section-wrap {
		padding: 0 10px 24px 24px;
	}

	.contents__input--toggle_btn2 label {
		display: block;
		float: left;
		cursor: pointer;
		width: 143px;
		height: 30px;
		line-height: 30px;
		margin: 0;
		padding: 12px 5px;
		border: 1px solid #666666;
		background: #fffffa;
		color: #555e64;
		font-size: 16px;
		text-align: center;
		transition: .2s;
	}

	.contents__input--toggle_btn2 input[type="radio"]:checked+label {
		background-color: #FFA02F;
		color: #262626;
	}

	.yatin-lineHeight {
		line-height: 3.5em;
	}

	.yatin-indent {
		margin-top: -10px;
	}

	.yatin-marginTop {
		margin-left: 149px;
	}

	.question_indent {
		margin-left: 17px;
	}

	.toggle_indent {
		margin-left: 34px;
	}

	.width-sinkoku {
		height: 120px;
	}
	
	.margin-tetyo {
		margin-top: 15px; 
		margin-left: 17px;
	}

	.btn-itiji-hozon {
		margin-bottom: 2%;
		margin-right: 1%;
	}

	.btn-kakunin {
		margin-bottom: 2%;
	}

	.btn-modoru {
		margin-left: 1%;
	}

	.kobo-label-display {
		display: flex;
	}

	.seiribango-margin {
		margin-top: -10px;
		margin-left: 40px;
	}
	
	.sintokyuTitle__margin {
		margin-top: 15px; margin-left: 30px;
	}

	.sintokyuCheck__margin {
		margin-top: 15px; margin-left: 60px;
	}

	.aiteidoTitle__margin {
		margin-top: 25px; margin-left: 30px;
	}

	.aiteidoCheck__margin {
		margin-top: 15px; margin-left: 60px;
	}

	.seitokyuTitle__margin {
		margin-top: 25px; margin-left: 30px;
	}

	.seitokyuCheck__margin {
		margin-top: 15px; margin-left: 60px;
	}

	.syogaitokyuTitle__margin {
		margin-top: 25px; margin-left: 30px;
	}

	.syogaitokyuCheck__margin {
		margin-top: 15px; margin-left: 60px;
	}

	.kobo__display {
		display: inline-grid;
	}

	.ninzuline__height {
		line-height: 3.2em;
	}

	.yatinEtc_margin {
		margin-left: 151px;
	}

	.margin_kobo_tyui {
		margin-left: 18px;
	}

	.div-width100 {
		width: 100%;
	}

}

/* 端末がスマホの場合 */
@media screen and (max-width: 767px) {

	.ninzuline__height {
		line-height: 3.2em;
	}

	.nuNinzuTitle__height {
		height: 45px;
	}

	.nuNinzulist__margin {
		margin-left: 22px;
	}

	.sintokyuTitle__margin {
		margin-top: 15px; margin-left: 30px;
	}

	.sintokyuCheck__margin {
		margin-top: 15px; margin-left: 60px;
	}

	.aiteidoTitle__margin {
		margin-top: 15px; margin-left: 30px;
	}

	.aiteidoCheck__margin {
		margin-top: 15px; margin-left: 60px;
	}

	.seitokyuTitle__margin {
		margin-top: 15px; margin-left: 30px;
	}

	.seitokyuCheck__margin {
		margin-top: 15px; margin-left: 60px;
	}

	.syogaitokyuTitle__margin {
		margin-top: 15px; margin-left: 50px;
	}

	.syogaitokyuCheck__margin {
		margin-top: 15px; margin-left: 60px;
	}

	.kobo__display {
		display: inline-grid;
	}

	.seiribango__div-margin {
		margin-top: 15px;
	}

	.padding__top-zero {
		padding-top: 0px !important;
	}

	.padding__bottom-zero {
		padding-bottom: 0px !important;
	}

	.margin__top-zero {
		margin-top: 0px !important;
	}

	.line-height {
		line-height: 25px !important;
	}

	.font-size {
		font-size: 18px !important;
	}

	.contents__div--PC {
		display: none;
	}

	/* 入力項目：必須マーク */
	.contents__hissu2 {
		margin: 6px 0 0 5px;
	}

	.mobile-radio-margin {
		margin-top: 5px !important;
	}

	.contents__main {
		margin-left: 3px !important;
		margin-right: 3px !important;
	}

	.check-koubo1 {
		margin-left: -20px !important;
		padding-left: 10px !important;
		margin-top: 15px;
	}

	.check-koubo2,
	.check-koubo3,
	.check-koubo4 {
		margin-left: -20px !important;
		padding-left: 10px !important;
		margin-top: 18px;
	}

	.margin-riyuTyui {
		margin-top: 20px;
	}

	.width-nowJyutaku {
		width: 90%;
	}

	.contents__enquete25 {
		margin-top: 10px;
		width: 90%;
	}

	.width-senyoArea {
		margin-right: 10px;
		width: 58px;
		text-align: right;
	}

	.width-seiriNo {
		margin-right: 10px;
		margin-left: 5px;
		width: 149px;
		text-align: right;
	}

	.netakiri-tyui,
	.tatinoki-tyui {
		line-height: 1.2em;
		float: left;
		margin-bottom: 3px;
	}

	.margin-netakiri {
		margin-top: 15px;
		margin-bottom: 3px;
		font-size: 18px !important;
	}

	.margin-yachin {
		margin-top: 25px;
	}

	.margin-yachinTyui1 {
		line-height: 1.2em;
		float: left;
		margin-bottom: 3px;
	}

	.margin-yachinTyui2 {
		line-height: 1.2em;
		float: left;
		margin-bottom: 3px;
	}

	.margin-madori {
		margin-top: 15px;
		line-height: 1.2em;
	}

	.margin-mensekiTyui {
		line-height: 1.2em;
		float: left;
		margin-top: 10px;
		margin-bottom: 3px;
	}

	.contents__btn--confirm{
		margin-top: 20px;
		margin-bottom: 20px;
		position: relative;
	}
	.detail tr:nth-child(even){
		background-color: #f1f2f5;
	}

	.detail th:nth-child(1) {
		width: auto;
	}
	.detail td:nth-child(2) {
		width: auto;
	}
	.content {
		display:none;
	}
	.contents__caution--multiple {
		line-height: 1.4em;
	}
	main{
		margin-right: -18px;
	}

	.contents__btn-statement {
		/* font-size: 18px; */
		text-align: left;
		padding-left: 15px;
		margin-top: 15px;
	}

	.width-seiyakuDoui {
		margin-left: -12px;
	}

	.width-enquete6,
	.width-enquete7,
	.width-enquete9 {
		height: 96px;
	}

	.margin-yatin {
		margin-bottom: 20px;
	}

	.contents__attention {
		margin-left: 20px;
		width: 90% !important;
	}
	.form-section {
		margin-left: 4px !important;
		margin-right: 4px !important;
	}
	.contents__konkyu-caution {
		margin-left: 5px;
	}

	.contents__input--toggle_btn2 label {
		display: block;
		float: left;
		cursor: pointer;
		width: 90px;
		height: 48px;
		line-height: 30px;
		margin: 0;
		padding: 12px 5px;
		border: 1px solid #666666;
		background: #fffffa;
		color: #555e64;
		font-size: 16px;
		text-align: center;
		transition: .2s;
	}

	.contents__input--toggle_btn2_toggle {
		display: block;
		float: left;
		cursor: pointer;
		width: 90px;
		height: 48px;
		line-height: 30px;
		margin: 0;
		padding: 12px 5px;
		border: 1px solid #666666;
		background: #fffffa;
		color: #555e64;
		font-size: 16px;
		text-align: center;
		transition: .2s;
	}

	.seiribango-margin {
		margin-left: 40px;
	}

	.contents__input--toggle_btn2 input[type="radio"]:checked+label {
		background-color: #FFA02F;
		color: #262626;
	}

	.atehamaranai-style {
		line-height: 17px !important;
		padding: 21px 5px 3px 5px !important;
	}

	.form-section .form-section-wrap {
		padding: 0 8px 10px 8px;
	}

	.yatin-lineHeight {
		line-height: 1.5em;
	}

	.yatin-simei-indent {
		margin-top: -27px;
	}

	.mosikomisyaKankei-margin {
		margin-top: 30px;
		margin-bottom: 25px;
	}

	.yatin-marginTop {
		margin-top: 10px;
	}

	.toggle_indent {
		margin-left: 17px;
	}

	.yatinEtc_margin {
		margin-left: 17px;
	}

	.kobo-margin {
		margin-left: -10px;
	}

	.width-sinkoku {
		height: 120px;
	}

	.margin-anketo {
		margin-left: -14px;
	}
	
	.margin__top-keiyakudoi {
		margin-top: 3px !important;
	}
}

/* IE対応 */
@media all and (-ms-high-contrast: none) {
	.contents__h2 {
		height: auto !important;
	}

	.width-textarea {
		width: 750px !important;
	}
}

_::-webkit-full-page-media, _:future, :root .margin__anketo-etc {
	margin-top: 8px;
}

_::-webkit-full-page-media, _:future, :root .seirino-error-msg {
	white-space: nowrap;
}

</style>